Ember.TEMPLATES["application"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "userLoggedIn", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(2, program2, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program2(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<nav role=\"navigation\" class=\"navbar navbar-default navbar-fixed-top\"><div class=\"navbar-header\">");
  stack1 = helpers.unless.call(depth0, "inEmbeddedPath", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "inEmbeddedPath", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(9, program9, data),fn:self.program(7, program7, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div class=\"navbar-right-btn pull-right visible-xs-block\"><div class=\"dropdown cursor-only\"><span data-toggle=\"dropdown\">");
  data.buffer.push(escapeExpression((helper = helpers['x-avatar'] || (depth0 && depth0['x-avatar']),options={hash:{
    'classNames': ("img img-circle"),
    'service': ("gravatar"),
    'user': ("userEmail"),
    'width': ("32"),
    'height': ("32")
  },hashTypes:{'classNames': "STRING",'service': "STRING",'user': "ID",'width': "STRING",'height': "STRING"},hashContexts:{'classNames': depth0,'service': depth0,'user': depth0,'width': depth0,'height': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "x-avatar", options))));
  data.buffer.push("<span class=\"caret\"></span></span><ul role=\"menu\" class=\"dropdown-menu dropdown-menu-right\"><li role=\"presentation\" class=\"dropdown-header\">Logged in as&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "userFullname", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</li><li><a href=\"https://www.kotive.com/how-to/design-taskflows/\" target=\"_blank\" class=\"cursor navbar-icon-link\"><img src=\"/images/brand/help.png\" width=\"15\" height=\"15\" />&nbsp;How to use the Designer...</a></li><li><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "openReferralModal", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push("><img src=\"/images/brand/gift.png\" width=\"15\" height=\"15\" />&nbsp;Give 100. Get 100</a></li>");
  stack1 = helpers['if'].call(depth0, "showBillingUpgradeLink", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(11, program11, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<li>");
  stack1 = (helper = helpers['link-to'] || (depth0 && depth0['link-to']),options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(13, program13, data),contexts:[depth0],types:["STRING"],data:data},helper ? helper.call(depth0, "logout", options) : helperMissing.call(depth0, "link-to", "logout", options));
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</li></ul></div></div></div>");
  stack1 = helpers.unless.call(depth0, "inEmbeddedPath", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(15, program15, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</nav>");
  return buffer;
  }
function program3(depth0,data) {
  
  
  data.buffer.push("<button type=\"button\" data-toggle=\"collapse\" data-target=\".navbar-ex1-collapse\" class=\"navbar-toggle\"><span class=\"sr-only\">Menu</span><span class=\"icon-bar\"></span><span class=\"icon-bar\"></span><span class=\"icon-bar\"></span></button>");
  }

function program5(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program7(depth0,data) {
  
  
  data.buffer.push("<a href=\"https://www.kotive.com\" target=\"_blank\" class=\"navbar-brand navbar-brand-xs visible-xs-block\"></a><a href=\"https://www.kotive.com\" target=\"_blank\" class=\"navbar-brand navbar-brand-sm hidden-xs\"></a>");
  }

function program9(depth0,data) {
  
  
  data.buffer.push("<a href=\"/hub/\" class=\"navbar-brand navbar-brand-xs visible-xs-block\"><img src=\"../images/1c572ac0.kotive-logo-square.png\" width=\"32\" height=\"32\" class=\"logo\" /></a><a href=\"/hub/\" class=\"navbar-brand navbar-brand-sm hidden-xs\"><img src=\"../images/1c572ac0.kotive-logo-square.png\" width=\"32\" height=\"32\" class=\"logo\" /></a>");
  }

function program11(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<li><a ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'href': ("billableUpgradeLink")
  },hashTypes:{'href': "STRING"},hashContexts:{'href': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">Upgrade my account</a></li>");
  return buffer;
  }

function program13(depth0,data) {
  
  
  data.buffer.push("<i class=\"glyphicon glyphicon-off\"></i>&nbsp;Logout");
  }

function program15(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<div class=\"collapse navbar-collapse navbar-ex1-collapse\"><ul class=\"nav navbar-nav\">");
  stack1 = helpers.each.call(depth0, "item", "in", "navItems", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(16, program16, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</ul><ul class=\"nav navbar-nav navbar-right hidden-xs\"><li><a href=\"https://www.kotive.com/how-to/design-taskflows/\" target=\"_blank\" class=\"cursor navbar-icon-link\"><img src=\"/images/brand/help.png\" width=\"32\" /></a></li><li><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "openReferralModal", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"cursor navbar-icon-link\"><img src=\"/images/brand/gift.png\" width=\"32\" /></a></li><li class=\"dropdown\"><a data-toggle=\"dropdown\" role=\"button\" aria-expanded=\"false\" class=\"dropdown-toggle navbar-icon-link cursor\">");
  data.buffer.push(escapeExpression((helper = helpers['x-avatar'] || (depth0 && depth0['x-avatar']),options={hash:{
    'classNames': ("img img-circle"),
    'service': ("gravatar"),
    'user': ("userEmail"),
    'width': ("32"),
    'height': ("32")
  },hashTypes:{'classNames': "STRING",'service': "STRING",'user': "ID",'width': "STRING",'height': "STRING"},hashContexts:{'classNames': depth0,'service': depth0,'user': depth0,'width': depth0,'height': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "x-avatar", options))));
  data.buffer.push("&nbsp;<span class=\"caret\"></span></a><ul role=\"menu\" class=\"dropdown-menu\"><li role=\"presentation\" class=\"dropdown-header\">Logged in as&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "userFullname", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</li>");
  stack1 = helpers['if'].call(depth0, "showBillingUpgradeLink", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(11, program11, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<li>");
  stack1 = (helper = helpers['link-to'] || (depth0 && depth0['link-to']),options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(13, program13, data),contexts:[depth0],types:["STRING"],data:data},helper ? helper.call(depth0, "logout", options) : helperMissing.call(depth0, "link-to", "logout", options));
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</li></ul></li></ul></div>");
  return buffer;
  }
function program16(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<li ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': ("item.isActive:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "goTo", "item", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","ID"],data:data})));
  data.buffer.push(" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":cursor item.isActive:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">");
  stack1 = helpers['if'].call(depth0, "item.icon", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(17, program17, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers._triageMustache.call(depth0, "item.name", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</a></li>");
  return buffer;
  }
function program17(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<span ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":glyphicon item.icon")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("></span>&nbsp;");
  return buffer;
  }

function program19(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<div class=\"kotive-updater minor-update alert alert-success\">A new version of the Designer is available&nbsp;&nbsp;<a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "minorReload", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;Refresh</a></div>");
  return buffer;
  }

function program21(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div class=\"kotive-updater major-update alert alert-success\">A new version of the Designer is available&nbsp;&nbsp;<a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "majorReload", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;Refresh now</a><p><em>You will not lose any work but will have to login again.</em></p><p><em>Refreshing automatically in&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "majorReloadTimeout", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("&nbsp;seconds...</em></p></div>");
  return buffer;
  }

  data.buffer.push("<div>");
  stack1 = helpers.unless.call(depth0, "hideNav", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div id=\"main\" class=\"container-fluid\"><div class=\"row-fluid\">");
  stack1 = helpers._triageMustache.call(depth0, "outlet", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div></div><div class=\"drop-tooltip-target-placeholder\"><div class=\"drop-tooltip-content\">");
  data.buffer.push(escapeExpression((helper = helpers.outlet || (depth0 && depth0.outlet),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data},helper ? helper.call(depth0, "drop", options) : helperMissing.call(depth0, "outlet", "drop", options))));
  data.buffer.push("</div></div><div class=\"modal-outlet\">");
  data.buffer.push(escapeExpression((helper = helpers.outlet || (depth0 && depth0.outlet),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data},helper ? helper.call(depth0, "modal", options) : helperMissing.call(depth0, "outlet", "modal", options))));
  data.buffer.push("</div>");
  stack1 = helpers['if'].call(depth0, "minorUpdateRequired", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(19, program19, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "majorUpdateRequired", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(21, program21, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  
});

Ember.TEMPLATES["components/atwho-content"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var escapeExpression=this.escapeExpression;


  data.buffer.push(escapeExpression(helpers._triageMustache.call(depth0, "parsedValue", {hash:{
    'unescaped': ("true")
  },hashTypes:{'unescaped': "STRING"},hashContexts:{'unescaped': depth0},contexts:[depth0],types:["ID"],data:data})));
  
});

Ember.TEMPLATES["components/atwho-field"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.textarea || (depth0 && depth0.textarea),options={hash:{
    'class': ("classes"),
    'rows': ("displayRows"),
    'value': ("parsedValue")
  },hashTypes:{'class': "ID",'rows': "ID",'value': "ID"},hashContexts:{'class': depth0,'rows': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "textarea", options))));
  }

function program3(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['atwho-content'] || (depth0 && depth0['atwho-content']),options={hash:{
    'class': ("classes"),
    'value': ("value"),
    'action': ("editField"),
    'store': ("store")
  },hashTypes:{'class': "ID",'value': "ID",'action': "STRING",'store': "ID"},hashContexts:{'class': depth0,'value': depth0,'action': depth0,'store': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "atwho-content", options))));
  }

  stack1 = helpers['if'].call(depth0, "showEditor", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["components/condition-add-activation"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', escapeExpression=this.escapeExpression;


  data.buffer.push("<div id=\"add-activation-condition\" class=\"row\"><div class=\"col-xs-12 text-center\"><br /><a id=\"js-add-activation-condition\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "createActivationCondition", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp;OR</a></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["components/condition-add-completion"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', escapeExpression=this.escapeExpression;


  data.buffer.push("<div id=\"add-completion-condition\" class=\"row\"><div class=\"col-xs-12 text-center\"><br /><a id=\"js-add-completion-condition\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "createCompletionCondition", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp;OR</a></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["components/condition-filterline-add"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', escapeExpression=this.escapeExpression;


  data.buffer.push("<div class=\"row\"><div class=\"col-xs-1\"></div><div class=\"col-xs-11\"><a id=\"js-add-filter\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "addFilter", "condition", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","ID"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-conditions-and\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp;AND</a></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["components/condition-filterline-and"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  


  data.buffer.push("<div class=\"col-xs-1\"><h5><span class=\"label label-default and-label\">AND</span></h5></div>");
  
});

Ember.TEMPLATES["components/condition-filterline-or"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("<span class=\"label label-default or-label\">OR</span>");
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

  data.buffer.push("<div class=\"row conditions-or\"><div class=\"col-xs-12 text-center\"><h5>");
  stack1 = helpers.unless.call(depth0, "isFirstCondition", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</h5></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["components/condition-filterline"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['kotive-chosen-select'] || (depth0 && depth0['kotive-chosen-select']),options={hash:{
    'classes': ("form-control"),
    'options': ("roleOptions"),
    'selectedKey': ("filter.value")
  },hashTypes:{'classes': "STRING",'options': "ID",'selectedKey': "ID"},hashContexts:{'classes': depth0,'options': depth0,'selectedKey': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-chosen-select", options))));
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['kotive-chosen-select'] || (depth0 && depth0['kotive-chosen-select']),options={hash:{
    'classes': ("form-control"),
    'options': ("valueOptions"),
    'selectedKey': ("filter.value")
  },hashTypes:{'classes': "STRING",'options': "ID",'selectedKey': "ID"},hashContexts:{'classes': depth0,'options': depth0,'selectedKey': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-chosen-select", options))));
  }

function program7(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'class': ("form-control"),
    'type': ("text"),
    'placeholder': ("Enter a value"),
    'value': ("filter.value")
  },hashTypes:{'class': "STRING",'type': "STRING",'placeholder': "STRING",'value': "ID"},hashContexts:{'class': depth0,'type': depth0,'placeholder': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  }

function program9(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'class': ("form-control datepicker"),
    'type': ("text"),
    'placeholder': ("Select a date"),
    'value': ("filter.value")
  },hashTypes:{'class': "STRING",'type': "STRING",'placeholder': "STRING",'value': "ID"},hashContexts:{'class': depth0,'type': depth0,'placeholder': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  }

  data.buffer.push("<form role=\"form\"><div class=\"row\"><div class=\"col-xs-1\"><h5><span ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":label :and-label filter.notFirstFilter:label-default")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">AND</span></h5></div><div class=\"col-xs-4\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-chosen-select'] || (depth0 && depth0['kotive-chosen-select']),options={hash:{
    'classes': ("chosen-select form-control"),
    'groupedOptions': ("propertyOptions"),
    'selectedKey': ("filter.property")
  },hashTypes:{'classes': "STRING",'groupedOptions': "ID",'selectedKey': "ID"},hashContexts:{'classes': depth0,'groupedOptions': depth0,'selectedKey': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-chosen-select", options))));
  data.buffer.push("</div><div class=\"col-xs-2\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-chosen-select'] || (depth0 && depth0['kotive-chosen-select']),options={hash:{
    'classes': ("form-control"),
    'options': ("comparisonOptions"),
    'selectedKey': ("filter.comparison")
  },hashTypes:{'classes': "STRING",'options': "ID",'selectedKey': "ID"},hashContexts:{'classes': depth0,'options': depth0,'selectedKey': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-chosen-select", options))));
  data.buffer.push("</div><div class=\"col-xs-4\">");
  stack1 = helpers['if'].call(depth0, "roleSelect", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "fieldSelect", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "textField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(7, program7, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "datePicker", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(9, program9, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div><div class=\"col-xs-1\"><h5><span aria-hidden=\"true\" id=\"js-remove-filter\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "removeFilter", "filter", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","ID"],data:data})));
  data.buffer.push(" class=\"glyphicon glyphicon-remove cursor\"></span></h5></div></div></form>");
  return buffer;
  
});

Ember.TEMPLATES["components/draw-helptext"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<p class=\"help-block\">");
  data.buffer.push(escapeExpression(helpers._triageMustache.call(depth0, "model.style.helptext", {hash:{
    'unescaped': ("true")
  },hashTypes:{'unescaped': "STRING"},hashContexts:{'unescaped': depth0},contexts:[depth0],types:["ID"],data:data})));
  data.buffer.push("</p>");
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, "hasHelpText", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["components/draw-kotive-field"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['kotive-field-input'] || (depth0 && depth0['kotive-field-input']),options={hash:{
    'model': ("model"),
    'mode': ("mode"),
    'value': ("value"),
    'name': ("name"),
    'store': ("store")
  },hashTypes:{'model': "ID",'mode': "ID",'value': "ID",'name': "ID",'store': "ID"},hashContexts:{'model': depth0,'mode': depth0,'value': depth0,'name': depth0,'store': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-field-input", options))));
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['kotive-field-check'] || (depth0 && depth0['kotive-field-check']),options={hash:{
    'model': ("model"),
    'mode': ("mode"),
    'value': ("value"),
    'name': ("name")
  },hashTypes:{'model': "ID",'mode': "ID",'value': "ID",'name': "ID"},hashContexts:{'model': depth0,'mode': depth0,'value': depth0,'name': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-field-check", options))));
  }

function program7(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['kotive-field-select'] || (depth0 && depth0['kotive-field-select']),options={hash:{
    'model': ("model"),
    'mode': ("mode"),
    'value': ("value"),
    'prompt': ("prompt"),
    'name': ("name")
  },hashTypes:{'model': "ID",'mode': "ID",'value': "ID",'prompt': "ID",'name': "ID"},hashContexts:{'model': depth0,'mode': depth0,'value': depth0,'prompt': depth0,'name': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-field-select", options))));
  }

function program9(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['kotive-field-radio'] || (depth0 && depth0['kotive-field-radio']),options={hash:{
    'model': ("model"),
    'mode': ("mode"),
    'value': ("value"),
    'name': ("name")
  },hashTypes:{'model': "ID",'mode': "ID",'value': "ID",'name': "ID"},hashContexts:{'model': depth0,'mode': depth0,'value': depth0,'name': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-field-radio", options))));
  }

function program11(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['kotive-field-submit'] || (depth0 && depth0['kotive-field-submit']),options={hash:{
    'model': ("model"),
    'mode': ("mode"),
    'value': ("value"),
    'name': ("name")
  },hashTypes:{'model': "ID",'mode': "ID",'value': "ID",'name': "ID"},hashContexts:{'model': depth0,'mode': depth0,'value': depth0,'name': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-field-submit", options))));
  }

function program13(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['kotive-field-divider'] || (depth0 && depth0['kotive-field-divider']),options={hash:{
    'model': ("model"),
    'mode': ("mode"),
    'name': ("name")
  },hashTypes:{'model': "ID",'mode': "ID",'name': "ID"},hashContexts:{'model': depth0,'mode': depth0,'name': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-field-divider", options))));
  }

function program15(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['kotive-field-paragraph'] || (depth0 && depth0['kotive-field-paragraph']),options={hash:{
    'model': ("model"),
    'mode': ("mode"),
    'name': ("name"),
    'store': ("store")
  },hashTypes:{'model': "ID",'mode': "ID",'name': "ID",'store': "ID"},hashContexts:{'model': depth0,'mode': depth0,'name': depth0,'store': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-field-paragraph", options))));
  }

function program17(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['kotive-field-textarea'] || (depth0 && depth0['kotive-field-textarea']),options={hash:{
    'model': ("model"),
    'mode': ("mode"),
    'value': ("value"),
    'name': ("name"),
    'store': ("store")
  },hashTypes:{'model': "ID",'mode': "ID",'value': "ID",'name': "ID",'store': "ID"},hashContexts:{'model': depth0,'mode': depth0,'value': depth0,'name': depth0,'store': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-field-textarea", options))));
  }

function program19(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['atwho-content'] || (depth0 && depth0['atwho-content']),options={hash:{
    'class': ("atwho-heading"),
    'value': ("value"),
    'store': ("store")
  },hashTypes:{'class': "STRING",'value': "ID",'store': "ID"},hashContexts:{'class': depth0,'value': depth0,'store': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "atwho-content", options))));
  }

function program21(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['atwho-content'] || (depth0 && depth0['atwho-content']),options={hash:{
    'class': ("kotive-field-section"),
    'value': ("value"),
    'store': ("store"),
    'tagName': ("div")
  },hashTypes:{'class': "STRING",'value': "ID",'store': "ID",'tagName': "STRING"},hashContexts:{'class': depth0,'value': depth0,'store': depth0,'tagName': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "atwho-content", options))));
  }

function program23(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['kotive-field-upload'] || (depth0 && depth0['kotive-field-upload']),options={hash:{
    'model': ("model"),
    'mode': ("mode"),
    'value': ("value"),
    'name': ("name"),
    'store': ("store")
  },hashTypes:{'model': "ID",'mode': "ID",'value': "ID",'name': "ID",'store': "ID"},hashContexts:{'model': depth0,'mode': depth0,'value': depth0,'name': depth0,'store': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-field-upload", options))));
  }

function program25(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['kotive-field-uploadshow'] || (depth0 && depth0['kotive-field-uploadshow']),options={hash:{
    'model': ("model"),
    'mode': ("mode"),
    'value': ("value"),
    'name': ("name"),
    'store': ("store")
  },hashTypes:{'model': "ID",'mode': "ID",'value': "ID",'name': "ID",'store': "ID"},hashContexts:{'model': depth0,'mode': depth0,'value': depth0,'name': depth0,'store': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-field-uploadshow", options))));
  }

  stack1 = helpers['if'].call(depth0, "inputField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "checkField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "selectField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(7, program7, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "radioField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(9, program9, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "buttonField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(11, program11, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "dividerField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(13, program13, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "paragraphField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(15, program15, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "textAreaField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(17, program17, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "heading", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(19, program19, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "sectionField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(21, program21, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "uploadField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(23, program23, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "uploadshowField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(25, program25, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  
});

Ember.TEMPLATES["components/draw-kotive-service-field"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'name': ("name")
  },hashTypes:{'name': "STRING"},hashContexts:{'name': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":form-group model.hasError:has-warning")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><label ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'for': ("inputId")
  },hashTypes:{'for': "STRING"},hashContexts:{'for': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" class=\"control-label\">");
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</label>&nbsp;&nbsp;");
  stack1 = helpers['if'].call(depth0, "model.isOptional", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(escapeExpression((helper = helpers['draw-helptext'] || (depth0 && depth0['draw-helptext']),options={hash:{
    'model': ("model")
  },hashTypes:{'model': "ID"},hashContexts:{'model': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "draw-helptext", options))));
  data.buffer.push(escapeExpression((helper = helpers['atwho-field'] || (depth0 && depth0['atwho-field']),options={hash:{
    'value': ("model.patternString"),
    'classes': ("classes"),
    'workflow': ("workflow"),
    'field': ("model"),
    'templateActivity': ("templateActivity"),
    'store': ("store"),
    'rows': ("rows")
  },hashTypes:{'value': "ID",'classes': "ID",'workflow': "ID",'field': "ID",'templateActivity': "ID",'store': "ID",'rows': "ID"},hashContexts:{'value': depth0,'classes': depth0,'workflow': depth0,'field': depth0,'templateActivity': depth0,'store': depth0,'rows': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "atwho-field", options))));
  data.buffer.push("</div>");
  return buffer;
  }
function program2(depth0,data) {
  
  
  data.buffer.push("<mark class=\"small text-muted\">&nbsp;optional&nbsp;</mark>");
  }

function program4(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program6(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['draw-kotive-field'] || (depth0 && depth0['draw-kotive-field']),options={hash:{
    'model': ("model"),
    'mode': ("mode"),
    'value': ("value"),
    'prompt': ("prompt"),
    'store': ("store")
  },hashTypes:{'model': "ID",'mode': "ID",'value': "ID",'prompt': "ID",'store': "ID"},hashContexts:{'model': depth0,'mode': depth0,'value': depth0,'prompt': depth0,'store': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "draw-kotive-field", options))));
  }

  stack1 = helpers['if'].call(depth0, "shotAtwhoComponent", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(6, program6, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["components/drop-tooltip-body"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1;


  data.buffer.push("<div class=\"drop-body\">");
  stack1 = helpers._triageMustache.call(depth0, "yield", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["components/drop-tooltip-footer-delete-confirm"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var stack1;
  stack1 = helpers._triageMustache.call(depth0, "yield", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }

function program3(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "closeDropTooltip", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-default\">Cancel</button>&nbsp;<button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "deleteAction", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-trash\"></span>&nbsp;Delete permanently</button>");
  return buffer;
  }

  data.buffer.push("<div class=\"drop-footer\">");
  stack1 = helpers['if'].call(depth0, "template", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["components/drop-tooltip-footer-yesno"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var stack1;
  stack1 = helpers._triageMustache.call(depth0, "yield", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }

function program3(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "clickedYes", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-danger\">Yes</button>&nbsp;<button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "clickedNo", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn\">No</button>");
  return buffer;
  }

  data.buffer.push("<div class=\"drop-footer\">");
  stack1 = helpers['if'].call(depth0, "template", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["components/drop-tooltip-footer"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var stack1;
  stack1 = helpers._triageMustache.call(depth0, "yield", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }

function program3(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button type=\"button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "submit", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\">Save</button>");
  return buffer;
  }

  data.buffer.push("<div class=\"drop-footer\">");
  stack1 = helpers['if'].call(depth0, "template", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["components/drop-tooltip-header"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button type=\"button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "closeDropTooltip", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"close\">&times;</button>");
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

  data.buffer.push("<div class=\"drop-header\">");
  stack1 = helpers['if'].call(depth0, "showCloseButton", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<h4>");
  stack1 = helpers._triageMustache.call(depth0, "title", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</h4></div>");
  return buffer;
  
});

Ember.TEMPLATES["components/drop-tooltip-target"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  data.buffer.push("<div class=\"drop-tooltip-target-placeholder\"><div class=\"drop-tooltip-content\">");
  data.buffer.push(escapeExpression((helper = helpers.outlet || (depth0 && depth0.outlet),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data},helper ? helper.call(depth0, "drop", options) : helperMissing.call(depth0, "outlet", "drop", options))));
  data.buffer.push("</div></div>");
  return buffer;
  
});

Ember.TEMPLATES["components/drop-tooltip"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1;


  stack1 = helpers._triageMustache.call(depth0, "yield", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["components/kotive-chosen-select"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<option>");
  stack1 = helpers._triageMustache.call(depth0, "prompt", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</option>");
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['kotive-option-helper'] || (depth0 && depth0['kotive-option-helper']),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["ID","ID"],data:data},helper ? helper.call(depth0, "option", "selectedKey", options) : helperMissing.call(depth0, "kotive-option-helper", "option", "selectedKey", options))));
  }

function program7(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<optgroup ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'label': ("group.label")
  },hashTypes:{'label': "STRING"},hashContexts:{'label': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">");
  stack1 = helpers.each.call(depth0, "option", "in", "group.options", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(5, program5, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</optgroup>");
  return buffer;
  }

  data.buffer.push("<select ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': ("classes")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">");
  stack1 = helpers['if'].call(depth0, "prompt", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers.each.call(depth0, "option", "in", "options", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(5, program5, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers.each.call(depth0, "group", "in", "groupedOptions", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(7, program7, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</select>");
  return buffer;
  
});

Ember.TEMPLATES["components/kotive-field-check"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("<mark class=\"small text-muted\">&nbsp;optional&nbsp;</mark>");
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  
  data.buffer.push("<div class=\"small text-muted\">&nbsp;No options available</div>");
  }

function program7(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "showPredefinedInfo", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(10, program10, data),fn:self.program(8, program8, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program8(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<mark class=\"small text-muted\">You've chosen a predefined list of&nbsp;<strong>");
  stack1 = helpers._triageMustache.call(depth0, "fieldTypeDescr", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</strong>,&nbsp;to be shown as&nbsp;<strong>checkboxes</strong></mark>");
  return buffer;
  }

function program10(depth0,data) {
  
  var stack1;
  stack1 = helpers.each.call(depth0, "option", "in", "model.patternOptions.completedSelections", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(11, program11, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program11(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "displayInline", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(14, program14, data),fn:self.program(12, program12, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program12(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<label class=\"checkbox-inline\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'disabled': ("model.readonly"),
    'checkedVals': ("values"),
    'value': ("option.key")
  },hashTypes:{'disabled': "ID",'checkedVals': "ID",'value': "ID"},hashContexts:{'disabled': depth0,'checkedVals': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  stack1 = helpers._triageMustache.call(depth0, "option.value", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</label>");
  return buffer;
  }

function program14(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<div class=\"checkbox\"><label>");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'disabled': ("model.readonly"),
    'checkedVals': ("values"),
    'value': ("option.key")
  },hashTypes:{'disabled': "ID",'checkedVals': "ID",'value': "ID"},hashContexts:{'disabled': depth0,'checkedVals': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  stack1 = helpers._triageMustache.call(depth0, "option.value", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</label></div>");
  return buffer;
  }

  data.buffer.push("<div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":form-group model.hasError:has-warning")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><label ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'for': ("inputId")
  },hashTypes:{'for': "STRING"},hashContexts:{'for': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" class=\"control-label\">");
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</label>&nbsp;&nbsp;");
  stack1 = helpers['if'].call(depth0, "model.isOptional", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div class=\"clearfix\"></div>");
  data.buffer.push(escapeExpression((helper = helpers['draw-helptext'] || (depth0 && depth0['draw-helptext']),options={hash:{
    'model': ("model")
  },hashTypes:{'model': "ID"},hashContexts:{'model': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "draw-helptext", options))));
  stack1 = helpers['if'].call(depth0, "isEmpty", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["components/kotive-field-divider"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("<div class=\"kotive-field-divider-info\">(divider)&nbsp;</div><br />");
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

  data.buffer.push("<hr class=\"kotive-field-divider\" />");
  stack1 = helpers['if'].call(depth0, "inDesignerMode", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  
});

Ember.TEMPLATES["components/kotive-field-input"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("<mark class=\"small text-muted\">&nbsp;optional&nbsp;</mark>");
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['atwho-content'] || (depth0 && depth0['atwho-content']),options={hash:{
    'class': ("form-control"),
    'value': ("value"),
    'store': ("store")
  },hashTypes:{'class': "STRING",'value': "ID",'store': "ID"},hashContexts:{'class': depth0,'value': depth0,'store': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "atwho-content", options))));
  }

function program7(depth0,data) {
  
  var buffer = '', stack1;
  stack1 = helpers['if'].call(depth0, "textField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(8, program8, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "dateField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(10, program10, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "emailField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(12, program12, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "numberField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(14, program14, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "passwordField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(16, program16, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "telField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(18, program18, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "urlField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(20, program20, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "timeField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(22, program22, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  }
function program8(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("text"),
    'class': ("form-control"),
    'value': ("value"),
    'disabled': ("model.readonly")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID",'disabled': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0,'disabled': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  }

function program10(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("date"),
    'class': ("form-control"),
    'value': ("value"),
    'disabled': ("model.readonly")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID",'disabled': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0,'disabled': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  }

function program12(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("email"),
    'class': ("form-control"),
    'value': ("value"),
    'disabled': ("model.readonly")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID",'disabled': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0,'disabled': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  }

function program14(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("number"),
    'class': ("form-control"),
    'value': ("value"),
    'disabled': ("model.readonly")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID",'disabled': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0,'disabled': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  }

function program16(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("password"),
    'class': ("form-control"),
    'value': ("value"),
    'disabled': ("model.readonly")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID",'disabled': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0,'disabled': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  }

function program18(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("tel"),
    'class': ("form-control"),
    'value': ("value"),
    'disabled': ("model.readonly")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID",'disabled': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0,'disabled': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  }

function program20(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("url"),
    'class': ("form-control"),
    'value': ("value"),
    'disabled': ("model.readonly")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID",'disabled': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0,'disabled': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  }

function program22(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("time"),
    'class': ("form-control"),
    'value': ("value"),
    'disabled': ("model.readonly")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID",'disabled': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0,'disabled': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  }

  data.buffer.push("<div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'name': ("name")
  },hashTypes:{'name': "STRING"},hashContexts:{'name': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":form-group model.hasError:has-warning")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><label ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'for': ("inputId")
  },hashTypes:{'for': "STRING"},hashContexts:{'for': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" class=\"control-label\">");
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</label>&nbsp;&nbsp;");
  stack1 = helpers['if'].call(depth0, "model.isOptional", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(escapeExpression((helper = helpers['draw-helptext'] || (depth0 && depth0['draw-helptext']),options={hash:{
    'model': ("model")
  },hashTypes:{'model': "ID"},hashContexts:{'model': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "draw-helptext", options))));
  stack1 = helpers['if'].call(depth0, "inDesignerMode", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["components/kotive-field-paragraph"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['atwho-content'] || (depth0 && depth0['atwho-content']),options={hash:{
    'class': ("kotive-field-paragraph"),
    'value': ("model.patternString"),
    'store': ("store"),
    'tagName': ("p")
  },hashTypes:{'class': "STRING",'value': "ID",'store': "ID",'tagName': "STRING"},hashContexts:{'class': depth0,'value': depth0,'store': depth0,'tagName': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "atwho-content", options))));
  }

function program3(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<div class=\"kotive-field-paragraph\">");
  data.buffer.push(escapeExpression(helpers._triageMustache.call(depth0, "model.value", {hash:{
    'unescaped': ("true")
  },hashTypes:{'unescaped': "STRING"},hashContexts:{'unescaped': depth0},contexts:[depth0],types:["ID"],data:data})));
  data.buffer.push("</div>");
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, "inDesignerMode", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["components/kotive-field-radio"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("<mark class=\"small text-muted\">&nbsp;optional&nbsp;</mark>");
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  
  data.buffer.push("<div class=\"small text-muted\">&nbsp;No options available</div>");
  }

function program7(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "showPredefinedInfo", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(10, program10, data),fn:self.program(8, program8, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program8(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<mark class=\"small text-muted\">You've chosen a predefined list of&nbsp;<strong>");
  stack1 = helpers._triageMustache.call(depth0, "fieldTypeDescr", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</strong>,&nbsp;to be shown as&nbsp;<strong>radiobuttons</strong></mark>");
  return buffer;
  }

function program10(depth0,data) {
  
  var stack1;
  stack1 = helpers.each.call(depth0, "option", "in", "model.patternOptions.completedSelections", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(11, program11, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program11(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "displayInline", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(14, program14, data),fn:self.program(12, program12, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program12(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<label class=\"radio-inline\">");
  data.buffer.push(escapeExpression((helper = helpers['radio-button'] || (depth0 && depth0['radio-button']),options={hash:{
    'value': ("option.key"),
    'selection': ("value"),
    'disabled': ("model.readonly")
  },hashTypes:{'value': "ID",'selection': "ID",'disabled': "ID"},hashContexts:{'value': depth0,'selection': depth0,'disabled': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "radio-button", options))));
  stack1 = helpers._triageMustache.call(depth0, "option.value", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</label>");
  return buffer;
  }

function program14(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<div class=\"radio\"><label>");
  data.buffer.push(escapeExpression((helper = helpers['radio-button'] || (depth0 && depth0['radio-button']),options={hash:{
    'value': ("option.key"),
    'selection': ("value"),
    'disabled': ("model.readonly")
  },hashTypes:{'value': "ID",'selection': "ID",'disabled': "ID"},hashContexts:{'value': depth0,'selection': depth0,'disabled': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "radio-button", options))));
  stack1 = helpers._triageMustache.call(depth0, "option.value", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</label></div>");
  return buffer;
  }

  data.buffer.push("<div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":form-group model.hasError:has-warning")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><label ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'for': ("inputId")
  },hashTypes:{'for': "STRING"},hashContexts:{'for': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" class=\"control-label\">");
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</label>&nbsp;&nbsp;");
  stack1 = helpers['if'].call(depth0, "model.isOptional", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div class=\"clearfix\"></div>");
  data.buffer.push(escapeExpression((helper = helpers['draw-helptext'] || (depth0 && depth0['draw-helptext']),options={hash:{
    'model': ("model")
  },hashTypes:{'model': "ID"},hashContexts:{'model': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "draw-helptext", options))));
  stack1 = helpers['if'].call(depth0, "isEmpty", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["components/kotive-field-select"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("<mark class=\"small text-muted\">&nbsp;optional&nbsp;</mark>");
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  
  data.buffer.push("<div class=\"small text-muted\">&nbsp;No options available</div>");
  }

function program7(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "showPredefinedInfo", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(10, program10, data),fn:self.program(8, program8, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program8(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<mark class=\"small text-muted\">You've chosen a predefined list of&nbsp;<strong>");
  stack1 = helpers._triageMustache.call(depth0, "fieldTypeDescr", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</strong>,&nbsp;to be shown as a&nbsp;<strong>select (dropdown)</strong></mark>");
  return buffer;
  }

function program10(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['kotive-select'] || (depth0 && depth0['kotive-select']),options={hash:{
    'model': ("model"),
    'value': ("value"),
    'prompt': ("prompt"),
    'disabled': ("model.readonly")
  },hashTypes:{'model': "ID",'value': "ID",'prompt': "ID",'disabled': "ID"},hashContexts:{'model': depth0,'value': depth0,'prompt': depth0,'disabled': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-select", options))));
  }

  data.buffer.push("<div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":form-group model.hasError:has-warning")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><label ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'for': ("inputId")
  },hashTypes:{'for': "STRING"},hashContexts:{'for': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" class=\"control-label\">");
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</label>&nbsp;&nbsp;");
  stack1 = helpers['if'].call(depth0, "model.isOptional", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(escapeExpression((helper = helpers['draw-helptext'] || (depth0 && depth0['draw-helptext']),options={hash:{
    'model': ("model")
  },hashTypes:{'model': "ID"},hashContexts:{'model': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "draw-helptext", options))));
  stack1 = helpers['if'].call(depth0, "isEmpty", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["components/kotive-field-submit"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression;


  data.buffer.push("<div class=\"kotive-button-container\"><button type=\"submit\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': ("model.style.classes")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">");
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</button></div>");
  return buffer;
  
});

Ember.TEMPLATES["components/kotive-field-textarea"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("<mark class=\"small text-muted\">&nbsp;optional&nbsp;</mark>");
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['atwho-content'] || (depth0 && depth0['atwho-content']),options={hash:{
    'class': ("form-control textarea"),
    'value': ("value"),
    'store': ("store")
  },hashTypes:{'class': "STRING",'value': "ID",'store': "ID"},hashContexts:{'class': depth0,'value': depth0,'store': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "atwho-content", options))));
  }

function program7(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.textarea || (depth0 && depth0.textarea),options={hash:{
    'value': ("value"),
    'id': ("inputId"),
    'disabled': ("model.readonly"),
    'class': ("form-control"),
    'rows': ("3")
  },hashTypes:{'value': "ID",'id': "ID",'disabled': "ID",'class': "STRING",'rows': "STRING"},hashContexts:{'value': depth0,'id': depth0,'disabled': depth0,'class': depth0,'rows': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "textarea", options))));
  }

  data.buffer.push("<div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":form-group model.hasError:has-warning")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><label ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'for': ("inputId")
  },hashTypes:{'for': "STRING"},hashContexts:{'for': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" class=\"control-label\">");
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</label>&nbsp;&nbsp;");
  stack1 = helpers['if'].call(depth0, "model.isOptional", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(escapeExpression((helper = helpers['draw-helptext'] || (depth0 && depth0['draw-helptext']),options={hash:{
    'model': ("model")
  },hashTypes:{'model': "ID"},hashContexts:{'model': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "draw-helptext", options))));
  stack1 = helpers['if'].call(depth0, "inDesignerMode", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["components/kotive-field-upload"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("<mark class=\"small text-muted\">&nbsp;optional&nbsp;</mark>");
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  
  data.buffer.push("<div class=\"drag-and-drop\"><a class=\"btn btn-success\"><img src=\"/images/a247bff8.icon-file-upload.png\" width=\"20\" />&nbsp;&nbsp;Choose files to upload</a></div>");
  }

function program7(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "chooseFile", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-sm\"><span class=\"glyphicon glyphicon-upload\"></span>&nbsp;Choose files to upload</button>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("hidden"),
    'id': ("inputId"),
    'value': ("value"),
    'disabled': ("model.readonly")
  },hashTypes:{'type': "STRING",'id': "ID",'value': "ID",'disabled': "ID"},hashContexts:{'type': depth0,'id': depth0,'value': depth0,'disabled': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  return buffer;
  }

  data.buffer.push("<div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":form-group model.hasError:has-warning")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><label ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'for': ("inputId")
  },hashTypes:{'for': "STRING"},hashContexts:{'for': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" class=\"control-label\">");
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</label>&nbsp;&nbsp;");
  stack1 = helpers['if'].call(depth0, "model.isOptional", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(escapeExpression((helper = helpers['draw-helptext'] || (depth0 && depth0['draw-helptext']),options={hash:{
    'model': ("model")
  },hashTypes:{'model': "ID"},hashContexts:{'model': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "draw-helptext", options))));
  stack1 = helpers['if'].call(depth0, "inDesignerMode", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["components/kotive-field-uploadshow"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("<mark class=\"small text-muted\">&nbsp;Files uploaded in previous tasks will be retrieved and shown.</mark>");
  }

  data.buffer.push("<div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":form-group model.hasError:has-warning")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><label ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'for': ("inputId")
  },hashTypes:{'for': "STRING"},hashContexts:{'for': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" class=\"control-label\">");
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</label>&nbsp;&nbsp;");
  data.buffer.push(escapeExpression((helper = helpers['draw-helptext'] || (depth0 && depth0['draw-helptext']),options={hash:{
    'model': ("model")
  },hashTypes:{'model': "ID"},hashContexts:{'model': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "draw-helptext", options))));
  stack1 = helpers['if'].call(depth0, "inDesignerMode", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(1, program1, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["components/kotive-select"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<option>");
  stack1 = helpers._triageMustache.call(depth0, "prompt", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</option>");
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['kotive-option-helper'] || (depth0 && depth0['kotive-option-helper']),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["ID","ID"],data:data},helper ? helper.call(depth0, "option", "value", options) : helperMissing.call(depth0, "kotive-option-helper", "option", "value", options))));
  }

  data.buffer.push("<select ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'disabled': ("model.readonly")
  },hashTypes:{'disabled': "STRING"},hashContexts:{'disabled': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" class=\"form-control kotive-selection-field\">");
  stack1 = helpers['if'].call(depth0, "prompt", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers.each.call(depth0, "option", "in", "model.patternOptions.completedSelections", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(5, program5, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</select>");
  return buffer;
  
});

Ember.TEMPLATES["components/modal-body"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1;


  data.buffer.push("<div class=\"modal-body\">");
  stack1 = helpers._triageMustache.call(depth0, "yield", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["components/modal-container"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1;


  data.buffer.push("<div id=\"kotive-modal\" data-backdrop=\"static\" style=\"display:none;\" class=\"modal\"><div class=\"modal-dialog\"><div class=\"modal-content\">");
  stack1 = helpers._triageMustache.call(depth0, "yield", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["components/modal-footer-yesno"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var stack1;
  stack1 = helpers._triageMustache.call(depth0, "yield", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }

function program3(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "clickedYes", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-danger\">Yes</button>&nbsp;<button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "clickedNo", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn\">No</button>");
  return buffer;
  }

  data.buffer.push("<div class=\"modal-footer\">");
  stack1 = helpers['if'].call(depth0, "template", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["components/modal-footer"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var stack1;
  stack1 = helpers._triageMustache.call(depth0, "yield", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }

function program3(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "closeModal", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-default\">Cancel</a>&nbsp;<button class=\"btn btn-success\">Save</button>");
  return buffer;
  }

  data.buffer.push("<div class=\"modal-footer\">");
  stack1 = helpers['if'].call(depth0, "template", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["components/modal-header"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button type=\"button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "closeModal", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"close\">&times;</button>");
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

  data.buffer.push("<div class=\"modal-header\">");
  stack1 = helpers['if'].call(depth0, "showCloseButton", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<h4>");
  stack1 = helpers._triageMustache.call(depth0, "title", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</h4></div>");
  return buffer;
  
});

Ember.TEMPLATES["components/modal-template-field"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1;


  data.buffer.push("<div tabindex=\"-1\" aria-hidden=\"true\" role=\"dialog\" id=\"modal-template-field\" class=\"modal\"><div class=\"modal-dialog\"><div class=\"modal-content\">");
  stack1 = helpers._triageMustache.call(depth0, "yield", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["components/oauth2-generate"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<h4><div class=\"label label-success\"><span class=\"glyphicon glyphicon-ok\"></span>&nbsp;&nbsp;Your ");
  stack1 = helpers._triageMustache.call(depth0, "serviceName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("&nbsp;account has successfully been connected.</div></h4>");
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div class=\"form-group\"><label class=\"control-label\"><mark class=\"text-muted\">You have not yet securely connected your ");
  stack1 = helpers._triageMustache.call(depth0, "serviceName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("&nbsp;account</mark></label><br /><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "execute", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\">Connect your ");
  stack1 = helpers._triageMustache.call(depth0, "serviceName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("&nbsp;account now &rarr;</a></div>");
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, "authenticated", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["components/show-alert"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1;


  data.buffer.push("<div class=\"alert alert-warning\">");
  stack1 = helpers._triageMustache.call(depth0, "message", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["components/switch-branch"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<strong>");
  stack1 = helpers._triageMustache.call(depth0, "group.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</strong><span class=\"pull-right\"><span class=\"label label-success\"><span class=\"glyphicon glyphicon-ok\"></span>&nbsp;Active&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "group.levelName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</span></span>");
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = '', stack1;
  stack1 = helpers._triageMustache.call(depth0, "group.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("&nbsp;<mark class=\"small text-muted\">");
  stack1 = helpers._triageMustache.call(depth0, "group.levelName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</mark>");
  return buffer;
  }

function program5(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['switch-branch'] || (depth0 && depth0['switch-branch']),options={hash:{
    'group': ("subGroup"),
    'position': ("nextPosition"),
    'activeGroupId': ("activeGroupId"),
    'groups': ("groups"),
    'action': ("setActive")
  },hashTypes:{'group': "ID",'position': "ID",'activeGroupId': "ID",'groups': "ID",'action': "STRING"},hashContexts:{'group': depth0,'position': depth0,'activeGroupId': depth0,'groups': depth0,'action': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "switch-branch", options))));
  }

function program7(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

  data.buffer.push("<tr ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "setActive", "group", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","ID"],data:data})));
  data.buffer.push(" class=\"cursor-only\"><td>");
  data.buffer.push(escapeExpression(helpers._triageMustache.call(depth0, "spacing", {hash:{
    'unescaped': ("true")
  },hashTypes:{'unescaped': "STRING"},hashContexts:{'unescaped': depth0},contexts:[depth0],types:["ID"],data:data})));
  data.buffer.push("<img width=\"25\" height=\"25\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'src': ("group.iconImage")
  },hashTypes:{'src': "STRING"},hashContexts:{'src': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" class=\"img-rounded\" />&nbsp;&nbsp;");
  stack1 = helpers['if'].call(depth0, "isActive", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</td></tr>");
  stack1 = helpers.each.call(depth0, "subGroup", "in", "subGroups", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  
});

Ember.TEMPLATES["condition"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<a id=\"js-add-activation-condition\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "createActivationCondition", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp;Add the first 'Activate' condition</a>");
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = '', stack1;
  stack1 = helpers.each.call(depth0, "condition", "in", "actConditions", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(4, program4, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers._triageMustache.call(depth0, "condition-add-activation", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push(escapeExpression((helper = helpers['condition-filterline-or'] || (depth0 && depth0['condition-filterline-or']),options={hash:{
    'condition': ("condition")
  },hashTypes:{'condition': "ID"},hashContexts:{'condition': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "condition-filterline-or", options))));
  data.buffer.push("<div class=\"row conditions-and-grouping\"><div class=\"col-xs-12\">");
  stack1 = helpers.each.call(depth0, "filter", "in", "condition.filters", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(escapeExpression((helper = helpers['condition-filterline-add'] || (depth0 && depth0['condition-filterline-add']),options={hash:{
    'condition': ("condition")
  },hashTypes:{'condition': "ID"},hashContexts:{'condition': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "condition-filterline-add", options))));
  data.buffer.push("</div></div>");
  return buffer;
  }
function program5(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['condition-filterline'] || (depth0 && depth0['condition-filterline']),options={hash:{
    'filterObj': ("filter"),
    'comparisonTypes': ("comparisonTypes"),
    'userRoles': ("userRoles"),
    'templateFields': ("groupedTemplateFields")
  },hashTypes:{'filterObj': "ID",'comparisonTypes': "ID",'userRoles': "ID",'templateFields': "ID"},hashContexts:{'filterObj': depth0,'comparisonTypes': depth0,'userRoles': depth0,'templateFields': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "condition-filterline", options))));
  }

function program7(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<a id=\"js-add-completion-condition\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "createCompletionCondition", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp;Add the first 'Complete' condition</a>");
  return buffer;
  }

function program11(depth0,data) {
  
  var buffer = '', stack1;
  stack1 = helpers.each.call(depth0, "condition", "in", "cmplConditions", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(4, program4, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers._triageMustache.call(depth0, "condition-add-completion", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  }

  data.buffer.push("<div class=\"row\"><div class=\"col-xs-12 conditions-header\"><h4>Activate this task when...</h4>");
  stack1 = helpers.unless.call(depth0, "hasActCond", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div><div class=\"row\"><div class=\"col-xs-12 conditions-header\"><h4>Complete this task when...</h4>");
  stack1 = helpers.unless.call(depth0, "hasCmplCond", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(11, program11, data),fn:self.program(9, program9, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div><br />");
  return buffer;
  
});

Ember.TEMPLATES["designer"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1;


  data.buffer.push("<div class=\"row site-view\"><div>");
  stack1 = helpers._triageMustache.call(depth0, "outlet", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div>");
  return buffer;
  
});

Ember.TEMPLATES["designer/workflows"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "noWorkflows", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program2(depth0,data) {
  
  
  data.buffer.push("<div class=\"panel-body text-center\">Welcome to the Designer!<br />Get started by<strong>&nbsp;designing your first taskflow</strong>.</div>");
  }

function program4(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div class=\"panel-body panel-kotive-taskflows\"><div class=\"list-group\"></div>");
  stack1 = helpers.each.call(depth0, "taskflow", "in", "sortedWorkflows", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(8, program8, data),fn:self.program(5, program5, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  }
function program5(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'id': ("taskflow.id")
  },hashTypes:{'id': "STRING"},hashContexts:{'id': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" class=\"list-group-item\">");
  stack1 = (helper = helpers['link-to'] || (depth0 && depth0['link-to']),options={hash:{
    'title': ("Continue designing the taskflow")
  },hashTypes:{'title': "STRING"},hashContexts:{'title': depth0},inverse:self.program(8, program8, data),fn:self.program(6, program6, data),contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "workflow", "taskflow.id", options) : helperMissing.call(depth0, "link-to", "workflow", "taskflow.id", options));
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div class=\"clearfix\"></div></div>");
  return buffer;
  }
function program6(depth0,data) {
  
  var stack1;
  stack1 = helpers._triageMustache.call(depth0, "taskflow.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }

function program8(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program10(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button id=\"js-add-new-taskflow\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "showAddActivityTemplateDrop", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success new-workflow\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp;Design a new taskflow</button>");
  return buffer;
  }

  data.buffer.push("<div class=\"container-medium center-block\"><div class=\"panel panel-kotive\"><div class=\"panel-heading\">Taskflows</div>");
  stack1 = helpers['if'].call(depth0, "showDesignerLinks", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(8, program8, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div class=\"panel-footer text-right\">");
  stack1 = helpers['if'].call(depth0, "showDesignerLinks", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(8, program8, data),fn:self.program(10, program10, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div>");
  stack1 = helpers._triageMustache.call(depth0, "outlet", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["forgot"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['show-alert'] || (depth0 && depth0['show-alert']),options={hash:{
    'message': ("validationMessage")
  },hashTypes:{'message': "ID"},hashContexts:{'message': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "show-alert", options))));
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  
  data.buffer.push("<div class=\"text-center\"><img src=\"/images/32201ecd.loading.gif\" /></div>");
  }

function program7(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button id=\"js-forgot-button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "userForgot", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-lg btn-block\">Send me reset instructions</button>");
  return buffer;
  }

  data.buffer.push("<div class=\"container-mini center-block\"><form><div class=\"panel panel-kotive\"><div class=\"panel-heading\"><h3>I forgot my password...</h3></div><div class=\"panel-body\"><p>Enter your email address below and we'll send you an email to reset your password.</p>");
  stack1 = helpers['if'].call(depth0, "validationErrors", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div id=\"js-api-unavailable\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":alert :alert-warning showApiAlert:shown:hidden")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><p>We're busy upgrading the server. Please try again in 10 minutes.</p></div><div class=\"form-group\"><label for=\"label\" class=\"control-label\">Your email address</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("email"),
    'class': ("form-control email-value"),
    'value': ("model.email")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div>");
  stack1 = helpers['if'].call(depth0, "processingForgot", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div></form><div class=\"login-footer\"><a href=\"#/login\">Mmm, I just remembered my password...</a></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["group-form"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  
  data.buffer.push("<p class=\"help-block\"><b>&nbsp;Required field</b></p>");
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  
  data.buffer.push("<img src=\"/images/32201ecd.loading.gif\" />&nbsp;Saving...");
  }

function program7(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<a class=\"btn btn-default\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "cancel", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(">Cancel</a>&nbsp;<button type=\"submit\" class=\"btn btn-success\">Save</button>");
  return buffer;
  }

  data.buffer.push("<form ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "save", {hash:{
    'on': ("submit")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push("><div class=\"panel-body\"><div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":form-group missingLabel:has-error")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><label for=\"label\" class=\"control-label\">The&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "levelCapitalized", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("&nbsp;name</label>");
  stack1 = helpers['if'].call(depth0, "missingLabel", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("text"),
    'class': ("form-control"),
    'id': ("label"),
    'value': ("model.label")
  },hashTypes:{'type': "STRING",'class': "STRING",'id': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'id': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div></div><div class=\"panel-footer\"><div class=\"pull-right\">");
  stack1 = helpers['if'].call(depth0, "doingSave", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div></form>");
  return buffer;
  
});

Ember.TEMPLATES["group"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1;


  stack1 = helpers._triageMustache.call(depth0, "outlet", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["group/create"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;


  data.buffer.push("<div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><div class=\"panel panel-kotive\"><div class=\"panel-heading\"><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "cancel", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"cursor\"><span class=\"glyphicon glyphicon-chevron-left icon-white\"></span></a>&nbsp;&nbsp;Add a new&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "model.levelName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{
    'doValidations': ("doValidations"),
    'missingLabel': ("missingLabel")
  },hashTypes:{'doValidations': "ID",'missingLabel': "ID"},hashContexts:{'doValidations': depth0,'missingLabel': depth0},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "group-form", "model", options) : helperMissing.call(depth0, "render", "group-form", "model", options))));
  data.buffer.push("</div></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["group/edit"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;


  data.buffer.push("<div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><div class=\"panel panel-kotive\"><div class=\"panel-heading\"><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "cancel", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"cursor\"><span class=\"glyphicon glyphicon-chevron-left icon-white\"></span></a>&nbsp;&nbsp;Update&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "model.levelName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{
    'doValidations': ("doValidations"),
    'missingLabel': ("missingLabel")
  },hashTypes:{'doValidations': "ID",'missingLabel': "ID"},hashContexts:{'doValidations': depth0,'missingLabel': depth0},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "group-form", "model", options) : helperMissing.call(depth0, "render", "group-form", "model", options))));
  data.buffer.push("</div></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["index"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  


  data.buffer.push("<div class=\"row\"><div class=\"col-xs-6 col-xs-offset-3 col-sm-4 col-sm-offset-4\"><div class=\"card-kotive\"><div class=\"card-body text-center\"><img src=\"/images/32201ecd.loading.gif\" />&nbsp;loading</div></div></div></div>");
  
});

Ember.TEMPLATES["invite-synchronise"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  


  data.buffer.push("<div class=\"row\"><div class=\"col-xs-6 col-xs-offset-3 col-sm-4 col-sm-offset-4\"><div class=\"card-kotive\"><div class=\"card-heading\">Syncing your account</div><div class=\"card-body\"><img src=\"/images/32201ecd.loading.gif\" />&nbsp;&nbsp;Fetching new information for your account.</div></div></div></div>");
  
});

Ember.TEMPLATES["login"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['show-alert'] || (depth0 && depth0['show-alert']),options={hash:{
    'message': ("validationMessage")
  },hashTypes:{'message': "ID"},hashContexts:{'message': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "show-alert", options))));
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  
  data.buffer.push("<div class=\"text-center\"><img src=\"/images/32201ecd.loading.gif\" /></div>");
  }

function program7(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button id=\"js-login-button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "userLogin", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-lg btn-block\">Login</button>");
  return buffer;
  }

  data.buffer.push("<div class=\"container-mini center-block\"><form id=\"js-login-form\"><div class=\"panel panel-kotive\"><div class=\"panel-heading\"><h3>Login</h3></div><div class=\"panel-body\">");
  stack1 = helpers['if'].call(depth0, "validationErrors", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":alert :alert-warning credentialErrors:shown:hidden")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><p>Your username and/or password is incorrect. Please try again.</p></div><div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":alert :alert-warning showAjaxError:shown:hidden")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><p>We're busy upgrading the server. Please try again in 10 minutes.</p></div><div class=\"form-group\"><label for=\"label\" class=\"control-label\">Username or email address</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("email"),
    'class': ("form-control email-value"),
    'value': ("model.email")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><div class=\"form-group\"><label for=\"label\" class=\"control-label\">Password</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("password"),
    'class': ("form-control password-value"),
    'value': ("model.password")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div>");
  stack1 = helpers['if'].call(depth0, "processingLogin", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div></form><div class=\"login-footer text-center\"><br /><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "openSignupModal", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"cursor\">Do not have an account? Sign up now! </a><br /><br /><a href=\"#/person/forgot_password\">Forgot your password?</a></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["logout"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  


  data.buffer.push("<div class=\"row\"><div class=\"col-xs-6 col-xs-offset-3 col-sm-4 col-sm-offset-4\"><div class=\"card-kotive\"><div class=\"card-heading\">Syncing your account</div><div class=\"card-body\"><img src=\"/images/32201ecd.loading.gif\" />&nbsp;&nbsp;Syncing your taskflows with the server.</div></div></div></div>");
  
});

Ember.TEMPLATES["no-access"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  


  data.buffer.push("<div class=\"container-small center-block\"><div class=\"panel panel-kotive\"><div class=\"panel-heading\"><span class=\"glyphicon glyphicon-lock\"></span>&nbsp;Sorry, you do not have access to this page</div><div class=\"panel-body\"><p>It seems you do not have the <strong>required permissions </strong>to access this page.</p><p>If you feel you should be able to access this page, please contact your <strong>App's administrator </strong>or <a href=\"mailto:support@kotive.com\">the Kotive support team</a>.</p></div></div></div>");
  
});

Ember.TEMPLATES["offline"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  


  data.buffer.push("<div class=\"row\"><div class=\"col-xs-6 col-xs-offset-3 col-sm-4 col-sm-offset-4\"><div class=\"card-kotive\"><div class=\"card-heading\">You are offline... </div><div class=\"card-body\">The functionality you have tried to access is only available when you are online.</div></div></div></div>");
  
});

Ember.TEMPLATES["people-management"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  


  data.buffer.push("<p>Some nice helpful text indicating to the user that they have are not logged in.</p>");
  
});

Ember.TEMPLATES["people/create"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, self=this, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;

function program1(depth0,data) {
  
  
  data.buffer.push("<span class=\"glyphicon glyphicon-chevron-left icon-white\"></span>");
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

  data.buffer.push("<div class=\"col-md-4 col-md-offset-4\"><div class=\"panel panel-kotive\"><div class=\"panel-heading\">");
  stack1 = (helper = helpers['link-to'] || (depth0 && depth0['link-to']),options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["STRING"],data:data},helper ? helper.call(depth0, "people", options) : helperMissing.call(depth0, "link-to", "people", options));
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("&nbsp;&nbsp;Add a new person to&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "group.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "person-form", "model", options) : helperMissing.call(depth0, "render", "person-form", "model", options))));
  data.buffer.push("</div></div>");
  return buffer;
  
});

Ember.TEMPLATES["people/index"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, self=this, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;

function program1(depth0,data) {
  
  var stack1, helper, options;
  stack1 = (helper = helpers['link-to'] || (depth0 && depth0['link-to']),options={hash:{
    'class': ("btn btn-success btn-sm")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[depth0],types:["STRING"],data:data},helper ? helper.call(depth0, "people.create", options) : helperMissing.call(depth0, "link-to", "people.create", options));
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program2(depth0,data) {
  
  
  data.buffer.push("<span class=\"glyphicon glyphicon-plus\"></span>&nbsp; Add a new person");
  }

function program4(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<a class=\"btn btn-success btn-sm\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "editRoles", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push("><span class=\"glyphicon glyphicon-list\"></span>&nbsp; Manage roles</a>");
  return buffer;
  }

function program8(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<li>");
  stack1 = (helper = helpers['link-to'] || (depth0 && depth0['link-to']),options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(9, program9, data),contexts:[depth0],types:["STRING"],data:data},helper ? helper.call(depth0, "people.create", options) : helperMissing.call(depth0, "link-to", "people.create", options));
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</li>");
  return buffer;
  }
function program9(depth0,data) {
  
  
  data.buffer.push("Add a new person");
  }

function program11(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<li><a href=\"#\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "editRoles", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(">Manage roles</a></li>");
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<li ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': ("crumb.active:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">");
  stack1 = helpers['if'].call(depth0, "crumb.active", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(16, program16, data),fn:self.program(14, program14, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</li>");
  return buffer;
  }
function program14(depth0,data) {
  
  var stack1;
  stack1 = helpers._triageMustache.call(depth0, "crumb.group.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }

function program16(depth0,data) {
  
  var stack1, helper, options;
  stack1 = (helper = helpers['link-to'] || (depth0 && depth0['link-to']),options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(14, program14, data),contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "people.index", "crumb.group.id", options) : helperMissing.call(depth0, "link-to", "people.index", "crumb.group.id", options));
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }

function program18(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<div align=\"center\">There are no&nbsp;<strong>");
  stack1 = helpers._triageMustache.call(depth0, "addLevelName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("s or people</strong>&nbsp;yet...<br /><br /><a class=\"btn btn-success\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "createGroup", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push("><span class=\"glyphicon glyphicon-plus\"></span>&nbsp; Add a new&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "addLevelName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</a>&nbsp;&nbsp;or&nbsp;&nbsp;");
  stack1 = (helper = helpers['link-to'] || (depth0 && depth0['link-to']),options={hash:{
    'class': ("btn btn-success")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[depth0],types:["STRING"],data:data},helper ? helper.call(depth0, "people.create", options) : helperMissing.call(depth0, "link-to", "people.create", options));
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<br /><br /></div>");
  return buffer;
  }

function program20(depth0,data) {
  
  
  data.buffer.push(escapeExpression(helpers.view.call(depth0, "datatable", {hash:{
    'columns': ("reportColumns"),
    'dataRows': ("dataRows"),
    'order': ("orderRows"),
    'classNames': ("table table-striped table-bordered table-hover"),
    'noDataMessage': ("Fetching data..."),
    'buttons': ("download")
  },hashTypes:{'columns': "ID",'dataRows': "ID",'order': "ID",'classNames': "STRING",'noDataMessage': "STRING",'buttons': "STRING"},hashContexts:{'columns': depth0,'dataRows': depth0,'order': depth0,'classNames': depth0,'noDataMessage': depth0,'buttons': depth0},contexts:[depth0],types:["STRING"],data:data})));
  }

  data.buffer.push("<div class=\"panel panel-kotive\"><div class=\"panel-heading\">People &amp;&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "addLevelName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("s<span class=\"pull-right hidden-xs\"><a class=\"btn btn-success btn-sm\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "createGroup", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push("><span class=\"glyphicon glyphicon-plus\"></span>&nbsp; Add a new&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "addLevelName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</a>&nbsp;");
  stack1 = helpers['if'].call(depth0, "showCreatePeople", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("&nbsp;");
  stack1 = helpers['if'].call(depth0, "showManageRoles", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(6, program6, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</span><span class=\"pull-right visible-xs-block\"><div class=\"btn-group\"><button type=\"button\" data-toggle=\"dropdown\" aria-expanded=\"false\" class=\"btn btn-success btn-sm dropdown-toggle\">Actions&nbsp;<span class=\"caret\"></span></button><ul role=\"menu\" class=\"dropdown-menu dropdown-menu-right\">");
  stack1 = helpers['if'].call(depth0, "showCreatePeople", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(8, program8, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<li><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "createGroup", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(">Add a new&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "addLevelName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</a></li>");
  stack1 = helpers['if'].call(depth0, "showManageRoles", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(11, program11, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</ul></div></span></div><div class=\"panel-body\"><ol class=\"breadcrumb\">");
  stack1 = helpers.each.call(depth0, "crumb", "in", "breadCrumbs", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(13, program13, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</ol>");
  stack1 = helpers['if'].call(depth0, "noPeopleGroupData", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(18, program18, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "hasPeopleGroupData", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(20, program20, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div>");
  return buffer;
  
});

Ember.TEMPLATES["permissions"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  data.buffer.push("<div class=\"panel panel-kotive\"><div class=\"panel-heading\">Permissions for {App}</div><div class=\"panel-body\"><table class=\"table table-striped table-hover valign-middle\"><thead><tr><th>&nbsp;</th><th>&nbsp;</th><th colspan=\"8\" style=\"white-space: nowrap;\">For this taskflow, this role can perform these actions...</th></tr><tr><th>Taskflow</th><th>Role</th><th width=\"75\" style=\"white-space: nowrap;\" class=\"text-center\">Has access...</th><th width=\"75\" style=\"white-space: nowrap;\" class=\"text-center\">View all entries...</th><th width=\"75\" style=\"white-space: nowrap;\" class=\"text-center\">Start new...</th><th width=\"75\" class=\"text-center\">Continue...</th><th width=\"75\" style=\"white-space: nowrap;\" class=\"text-center\">View history...</th><th width=\"75\" style=\"white-space: nowrap;\" class=\"text-center\">View audits...</th><th width=\"75\" class=\"text-center\">Delete...</th><th width=\"75\" style=\"white-space: nowrap;\" class=\"text-center\">Customize UI...</th></tr></thead><tbody><tr><td>Procurement</td><td>Manager</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("access"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("all"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("start"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("continue"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("history"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("audits"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("delete"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("customize"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td></tr><tr><td>Procurement</td><td>Exco</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("access"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("all"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("start"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("continue"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("history"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("audits"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("delete"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("customize"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td></tr><tr><td>Supplier</td><td>Manager</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("access"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("all"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("start"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("continue"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("history"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("audits"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("delete"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("customize"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td></tr><tr><td>Supplier</td><td>Exco</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("access"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("all"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("start"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("continue"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("history"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("audits"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("delete"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td><td class=\"text-center\">");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("customize"),
    'selection': ("selected")
  },hashTypes:{'value': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  data.buffer.push("</td></tr></tbody></table></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["person-form"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("<p class=\"help-block\"><b>Required field</b></p>");
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<b>&nbsp;-&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "invalidEmailMessage", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</b>");
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<div class=\"checkbox\"><label>");
  data.buffer.push(escapeExpression((helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'value': ("role.key"),
    'checkedVals': ("selectedRoles"),
    'disabled': ("role.isDisabled")
  },hashTypes:{'value': "ID",'checkedVals': "ID",'disabled': "ID"},hashContexts:{'value': depth0,'checkedVals': depth0,'disabled': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options))));
  stack1 = helpers._triageMustache.call(depth0, "role.value", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</label></div>");
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<label for=\"invite\" class=\"control-label\">Send an invitation email?</label>&nbsp;&nbsp;<mark class=\"small text-muted\">&nbsp;optional&nbsp;</mark><p class=\"help-block\">The email consists of short, human-friendly instructions and a link to join.</p><div class=\"checkbox\"><label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("checkbox"),
    'checked': ("sendInviteEmail")
  },hashTypes:{'type': "STRING",'checked': "ID"},hashContexts:{'type': depth0,'checked': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("Yes, send an invitation email to this person.</label></div>");
  return buffer;
  }

function program11(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<label for=\"invite\" class=\"control-label\">Send a password reset email?</label>&nbsp;&nbsp;<mark class=\"small text-muted\">&nbsp;optional&nbsp;</mark><p class=\"help-block\">The email consists of short, human-friendly instructions and a link to reset their password.</p><div class=\"checkbox\"><label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("checkbox"),
    'checked': ("sendPasswordResetEmail")
  },hashTypes:{'type': "STRING",'checked': "ID"},hashContexts:{'type': depth0,'checked': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("Yes, send a password reset email to this person.</label></div>");
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<img src=\"/images/32201ecd.loading.gif\" />&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "savingStatusMessage", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  }

function program15(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  stack1 = (helper = helpers['link-to'] || (depth0 && depth0['link-to']),options={hash:{
    'class': ("btn btn-default")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},inverse:self.program(3, program3, data),fn:self.program(16, program16, data),contexts:[depth0],types:["STRING"],data:data},helper ? helper.call(depth0, "people", options) : helperMissing.call(depth0, "link-to", "people", options));
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("&nbsp;<button type=\"submit\" class=\"btn btn-success\">Save</button>");
  return buffer;
  }
function program16(depth0,data) {
  
  
  data.buffer.push("Cancel");
  }

  data.buffer.push("<form role=\"form\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "save", {hash:{
    'on': ("submit")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push("><div class=\"panel-body\"><div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":form-group missingFirstName:has-error")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><label for=\"firstname\" class=\"control-label\">Firstname</label>");
  stack1 = helpers['if'].call(depth0, "missingFirstName", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("firstname"),
    'class': ("form-control"),
    'disabled': ("model.alreadyExists"),
    'value': ("model.firstname")
  },hashTypes:{'type': "STRING",'class': "STRING",'disabled': "ID",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'disabled': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":form-group missingLastName:has-error")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><label for=\"lastname\" class=\"control-label\">Lastname</label>");
  stack1 = helpers['if'].call(depth0, "missingLastName", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("lastname"),
    'class': ("form-control"),
    'disabled': ("model.alreadyExists"),
    'value': ("model.lastname")
  },hashTypes:{'type': "STRING",'class': "STRING",'disabled': "ID",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'disabled': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":form-group showInvalidEmailMessage:has-error")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><label for=\"email\" class=\"control-label\">Email</label><p class=\"help-block\">The person's email address will also be their username");
  stack1 = helpers['if'].call(depth0, "showInvalidEmailMessage", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</p>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("email"),
    'class': ("form-control email-input"),
    'disabled': ("model.alreadyExists"),
    'value': ("model.username")
  },hashTypes:{'type': "STRING",'class': "STRING",'disabled': "ID",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'disabled': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><div class=\"form-group\"><label for=\"mobile\" class=\"control-label\">Mobile</label>&nbsp;&nbsp;<mark class=\"small text-muted\">&nbsp;optional&nbsp;</mark>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("mobile"),
    'class': ("form-control"),
    'disabled': ("model.alreadyExists"),
    'value': ("model.mobile")
  },hashTypes:{'type': "STRING",'class': "STRING",'disabled': "ID",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'disabled': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><hr /><div class=\"form-group\"><label for=\"roles\" class=\"control-label\">Roles</label><p class=\"help-block\">In addition to having access to&nbsp;<strong>");
  stack1 = helpers._triageMustache.call(depth0, "group.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</strong>&nbsp;and all the organizations and/or teams underneath it, the following selected roles will be associated with the person and will give them certain access rights.</p>");
  stack1 = helpers.each.call(depth0, "role", "in", "sortedRoles", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(7, program7, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div><hr /><div class=\"form-group\">");
  stack1 = helpers['if'].call(depth0, "model.isNew", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(11, program11, data),fn:self.program(9, program9, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div><div class=\"panel-footer\"><div class=\"pull-right\">");
  stack1 = helpers['if'].call(depth0, "savingPerson", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(15, program15, data),fn:self.program(13, program13, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div></form>");
  return buffer;
  
});

Ember.TEMPLATES["person/edit"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, self=this, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;

function program1(depth0,data) {
  
  
  data.buffer.push("<span class=\"glyphicon glyphicon-chevron-left icon-white\"></span>");
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

  data.buffer.push("<div class=\"col-md-4 col-md-offset-4\"><div class=\"panel panel-kotive\"><div class=\"panel-heading\">");
  stack1 = (helper = helpers['link-to'] || (depth0 && depth0['link-to']),options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["STRING"],data:data},helper ? helper.call(depth0, "people", options) : helperMissing.call(depth0, "link-to", "people", options));
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("&nbsp;&nbsp;Update details for&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "model.descriptor", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "person-form", "model", options) : helperMissing.call(depth0, "render", "person-form", "model", options))));
  data.buffer.push("</div></div>");
  return buffer;
  
});

Ember.TEMPLATES["referrals"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push(escapeExpression((helper = helpers['modal-header'] || (depth0 && depth0['modal-header']),options={hash:{
    'title': ("Invite your friends")
  },hashTypes:{'title': "STRING"},hashContexts:{'title': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "modal-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(9, program9, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-body']) { stack1 = blockHelperMissing.call(depth0, 'modal-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(9, program9, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(9, program9, data),fn:self.program(13, program13, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-footer']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-footer']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-footer']) { stack1 = blockHelperMissing.call(depth0, 'modal-footer', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(9, program9, data),fn:self.program(13, program13, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div class=\"row\"><div class=\"col-md-12 text-center\"><img src=\"/images/brand/gift.png\" width=\"125\" /><h3>Get 100 task executions for free<br />when you invite a friend</h3>Every person who signs up using your referral link will receive<strong>&nbsp;100 task executions</strong>.<br />You will also receive an<strong>&nbsp;extra 100 task executions&nbsp;</strong>for every referral who signs up.<br /><hr />");
  stack1 = helpers['if'].call(depth0, "loadingReferral", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div><div class=\"row\"><div class=\"col-md-12 text-left\"><strong>Referral Program conditions</strong><br />In addition to our&nbsp;<a href=\"http://kotive.com/terms\" target=\"_blank\">terms &amp; conditions</a>&nbsp;the following applies for Kotive's Referral Program:<ol><li>When a person visits your referral link for the first time, our website will know about it for 45 days. (We store a cookie that remains valid for 45 days unless the person removes/blocks cookies.)</li><li>The gifts are only issued when a new user registers and confirms a Maker account.</li><li>The gifts cannot be exchanged for money or transfered to other accounts.</li><li>No SPAM policy. You must comply with all up-to-date \"SPAM\" laws.</li><li>We may change the gift you and/or your referrals receive from time to time without prior notice.</li><li>We may decide to cancel our Referral Program without giving prior notice.</li></ol></div></div>");
  return buffer;
  }
function program3(depth0,data) {
  
  
  data.buffer.push("<img src=\"/images/32201ecd.loading.gif\" />&nbsp;&nbsp;loading your referral...");
  }

function program5(depth0,data) {
  
  var buffer = '', stack1;
  stack1 = helpers['if'].call(depth0, "hasCompanyGroup", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(11, program11, data),fn:self.program(6, program6, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<hr />");
  return buffer;
  }
function program6(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<strong>Easy ways to share your referral link with others:</strong><br /><a ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'href': ("emailLink")
  },hashTypes:{'href': "STRING"},hashContexts:{'href': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">Email</a>&nbsp;&nbsp;<a ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'href': ("twitterLink")
  },hashTypes:{'href': "STRING"},hashContexts:{'href': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" target=\"_blank\">Twitter</a>&nbsp;&nbsp;<a ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'href': ("facebookLink")
  },hashTypes:{'href': "STRING"},hashContexts:{'href': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" target=\"_blank\">Facebook</a>&nbsp;&nbsp;<a ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'href': ("linkedInLink")
  },hashTypes:{'href': "STRING"},hashContexts:{'href': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" target=\"_blank\">LinkedIn</a>&nbsp;&nbsp;<a ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'href': ("googlePlusLink")
  },hashTypes:{'href': "STRING"},hashContexts:{'href': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" target=\"_blank\">Google+</a><br /><br /><strong>Your personal referral link to invite your friends:</strong><br /><input type=\"text\" readonly ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'value': ("referralLink")
  },hashTypes:{'value': "STRING"},hashContexts:{'value': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "highlightReferralToken", {hash:{
    'on': ("mouseEnter")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"form-control kotive-embedded-scripts text-center\" /><br />");
  stack1 = helpers['if'].call(depth0, "showCompanySelector", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(9, program9, data),fn:self.program(7, program7, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  }
function program7(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<strong>Which maker account should your gifts be sent to:</strong>");
  data.buffer.push(escapeExpression((helper = helpers['kotive-chosen-select'] || (depth0 && depth0['kotive-chosen-select']),options={hash:{
    'classes': ("form-control"),
    'options': ("companyOptions"),
    'selectedKey': ("selectedCompanyId")
  },hashTypes:{'classes': "STRING",'options': "ID",'selectedKey': "ID"},hashContexts:{'classes': depth0,'options': depth0,'selectedKey': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-chosen-select", options))));
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program11(depth0,data) {
  
  
  data.buffer.push("<p>Sorry but you do not have a maker account for us to link your gifts to.</p><p>Please create a maker account first.</p>");
  }

function program13(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "closeModal", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\">Done</a>");
  return buffer;
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(9, program9, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-container']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-container']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-container']) { stack1 = blockHelperMissing.call(depth0, 'modal-container', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(9, program9, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["registration"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("<div class=\"text-center\"><img src=\"/images/32201ecd.loading.gif\" /></div>");
  }

function program3(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button id=\"js-confirm-button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "confirmSignup", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-lg btn-block\">Save</button>");
  return buffer;
  }

  data.buffer.push("<div class=\"container-mini center-block\"><form><div class=\"panel panel-kotive\"><div class=\"panel-heading\"><h3>Welcome to Kotive!</h3></div><div class=\"panel-body\"><div id=\"js-password-alert\" class=\"alert alert-warning hidden\"><p>Please enter a strong password. The longer the better...</p></div><div id=\"js-company-alert\" class=\"alert alert-warning hidden\"><p>You need a company or organization name.</p></div><div id=\"js-api-error\" class=\"alert alert-warning hidden\"><p>We're busy upgrading the server. Please try again in 10 minutes.</p></div><div class=\"form-group\"><label for=\"label\" class=\"control-label\">Email</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("email"),
    'class': ("form-control email-value"),
    'value': ("model.email"),
    'readonly': (true)
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID",'readonly': "BOOLEAN"},hashContexts:{'type': depth0,'class': depth0,'value': depth0,'readonly': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><div class=\"form-group\"><label for=\"firstName\" class=\"control-label\">Firstname&nbsp;</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("firstName"),
    'class': ("form-control first-name-value"),
    'value': ("model.firstname")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><div class=\"form-group\"><label for=\"lastName\" class=\"control-label\">Lastname&nbsp;</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("lastName"),
    'class': ("form-control last-name-value"),
    'value': ("model.lastname")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><div class=\"form-group\"><label for=\"label\" class=\"control-label\">Password</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("password"),
    'class': ("form-control password-value"),
    'value': ("model.password"),
    'required': (true)
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID",'required': "BOOLEAN"},hashContexts:{'type': depth0,'class': depth0,'value': depth0,'required': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><div class=\"form-group\"><label for=\"label\" class=\"control-label\">Name your Maker account</label><p class=\"help-block\">E.g. the name of your company, organization or team.</p>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("text"),
    'class': ("form-control company-value"),
    'value': ("model.company"),
    'required': (true)
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID",'required': "BOOLEAN"},hashContexts:{'type': depth0,'class': depth0,'value': depth0,'required': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div>");
  stack1 = helpers['if'].call(depth0, "processingRegistration", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div></form><div class=\"clearfix\"></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["report-column-chooser"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<form id=\"column-chooser-form\" role=\"form\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "submit", {hash:{
    'on': ("submit")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" onsubmit=\"return false;\">");
  data.buffer.push(escapeExpression((helper = helpers['drop-tooltip-header'] || (depth0 && depth0['drop-tooltip-header']),options={hash:{
    'title': ("Customize the table's columns")
  },hashTypes:{'title': "STRING"},hashContexts:{'title': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "drop-tooltip-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip-body']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(11, program11, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip-footer']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip-footer']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip-footer']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip-footer', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(11, program11, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</form>");
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<small>Add or remove columns you want displayed</small><div class=\"column-options-selections\">");
  stack1 = helpers['if'].call(depth0, "columnsLoaded", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(9, program9, data),fn:self.program(3, program3, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  }
function program3(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<select data-placeholder=\"Choose columns from this taskflow\" multiple=\"\" class=\"chosen-select\">");
  stack1 = helpers.each.call(depth0, "columnOpt", "in", "columnOptions", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(4, program4, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</select>");
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<optgroup ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'label': ("columnOpt.label")
  },hashTypes:{'label': "STRING"},hashContexts:{'label': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">");
  stack1 = helpers.each.call(depth0, "field", "in", "columnOpt.fields", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</optgroup>");
  return buffer;
  }
function program5(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<option ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'value': ("field.id")
  },hashTypes:{'value': "STRING"},hashContexts:{'value': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'selected': ("field.selected")
  },hashTypes:{'selected': "STRING"},hashContexts:{'selected': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">");
  stack1 = helpers._triageMustache.call(depth0, "field.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</option>");
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program9(depth0,data) {
  
  
  data.buffer.push("<small><img src=\"/images/32201ecd.loading.gif\" />&nbsp;loading</small>");
  }

function program11(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "model.columnsChanged", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(14, program14, data),fn:self.program(12, program12, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program12(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button type=\"button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "applyColumnChanges", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;Refresh columns</button>");
  return buffer;
  }

function program14(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button type=\"button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "closeDropTooltip", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-default\">&nbsp;Close</button>");
  return buffer;
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["report-history"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<span class=\"timeline-start-label\"><span class=\"glyphicon glyphicon-chevron-left icon-white cursor-only\"></span>&nbsp;&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "report.workflow.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</span>");
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  
  data.buffer.push("<div class=\"timeline-card\"><div class=\"timeline-img\"><img src=\"/images/32201ecd.loading.gif\" class=\"loading-img\" /></div></div>");
  }

function program7(depth0,data) {
  
  var stack1;
  stack1 = helpers.each.call(depth0, "record", "in", "model.records", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(8, program8, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program8(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<div class=\"timeline-card\"><div class=\"timeline-img\"><img ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'src': ("record.icon")
  },hashTypes:{'src': "STRING"},hashContexts:{'src': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" /></div><div class=\"timeline-content\"><div class=\"card-heading\">");
  stack1 = helpers._triageMustache.call(depth0, "record.activityData.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "record.activityData.serviceResponses", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(9, program9, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div><div class=\"card-body\"><table class=\"table table-keyvalue-no-border\"><tbody>");
  stack1 = helpers.each.call(depth0, "field", "in", "record.activityData.fields", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(12, program12, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</tbody></table></div>");
  stack1 = helpers['if'].call(depth0, "record.activityData.serviceResponses", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(15, program15, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div class=\"timeline-timestamp\"><strong>");
  stack1 = helpers._triageMustache.call(depth0, "record.date", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</strong>,&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "record.time", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div class=\"visible-md-block visible-lg-block\">");
  data.buffer.push(escapeExpression((helper = helpers['x-avatar'] || (depth0 && depth0['x-avatar']),options={hash:{
    'classNames': ("img img-circle"),
    'service': ("gravatar"),
    'user': ("record.user.email"),
    'width': ("25"),
    'height': ("25")
  },hashTypes:{'classNames': "STRING",'service': "STRING",'user': "ID",'width': "STRING",'height': "STRING"},hashContexts:{'classNames': depth0,'service': depth0,'user': depth0,'width': depth0,'height': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "x-avatar", options))));
  data.buffer.push("<strong>&nbsp;&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "record.user.displayName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</strong></div><div class=\"visible-xs-inline visible-sm-inline\"><div class=\"pull-right\">");
  data.buffer.push(escapeExpression((helper = helpers['x-avatar'] || (depth0 && depth0['x-avatar']),options={hash:{
    'classNames': ("img img-circle"),
    'service': ("gravatar"),
    'user': ("record.user.email"),
    'width': ("25"),
    'height': ("25")
  },hashTypes:{'classNames': "STRING",'service': "STRING",'user': "ID",'width': "STRING",'height': "STRING"},hashContexts:{'classNames': depth0,'service': depth0,'user': depth0,'width': depth0,'height': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "x-avatar", options))));
  data.buffer.push("<strong>&nbsp;&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "record.user.displayName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</strong></div></div></div></div></div>");
  return buffer;
  }
function program9(depth0,data) {
  
  var stack1;
  stack1 = helpers.unless.call(depth0, "record.responseSuccess", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(10, program10, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program10(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<div class=\"pull-right\"><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "retryTaskflow", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-sm btn-danger\">Retry?</a></div>");
  return buffer;
  }

function program12(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<tr><td>");
  stack1 = helpers._triageMustache.call(depth0, "field.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers.unless.call(depth0, "field.required", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(13, program13, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</td><td>");
  data.buffer.push(escapeExpression(helpers._triageMustache.call(depth0, "field.value", {hash:{
    'unescaped': ("true")
  },hashTypes:{'unescaped': "STRING"},hashContexts:{'unescaped': depth0},contexts:[depth0],types:["ID"],data:data})));
  data.buffer.push("</td></tr>");
  return buffer;
  }
function program13(depth0,data) {
  
  
  data.buffer.push("&nbsp;<mark class=\"small text-muted\">&nbsp;optional&nbsp;</mark>");
  }

function program15(depth0,data) {
  
  var buffer = '', stack1;
  stack1 = helpers['if'].call(depth0, "record.responseSuccess", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(18, program18, data),fn:self.program(16, program16, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div class=\"card-body\"><table class=\"table table-keyvalue-no-border\"><tbody>");
  stack1 = helpers.each.call(depth0, "response", "in", "record.activityData.serviceResponses", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(20, program20, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</tbody></table></div>");
  return buffer;
  }
function program16(depth0,data) {
  
  
  data.buffer.push("<div class=\"card-subheading text-center\"><span class=\"glyphicon glyphicon-ok\"></span>&nbsp;&nbsp;The task completed successfully</div>");
  }

function program18(depth0,data) {
  
  
  data.buffer.push("<div class=\"card-subheading text-center alert-danger\"><span class=\"glyphicon glyphicon-warning-sign\"></span>&nbsp;&nbsp;The task failed...</div>");
  }

function program20(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<tr><td>");
  stack1 = helpers._triageMustache.call(depth0, "response.key", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</td><td>");
  data.buffer.push(escapeExpression(helpers._triageMustache.call(depth0, "response.value", {hash:{
    'unescaped': ("true")
  },hashTypes:{'unescaped': "STRING"},hashContexts:{'unescaped': depth0},contexts:[depth0],types:["ID"],data:data})));
  data.buffer.push("</td></tr>");
  return buffer;
  }

  data.buffer.push("<div class=\"clearfix\"></div><div id=\"timeline\" class=\"timeline-container\"><div class=\"timeline-start\">");
  stack1 = (helper = helpers['link-to'] || (depth0 && depth0['link-to']),options={hash:{
    'title': ("Go back to the report"),
    'class': ("whitelink")
  },hashTypes:{'title': "STRING",'class': "STRING"},hashContexts:{'title': depth0,'class': depth0},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["STRING"],data:data},helper ? helper.call(depth0, "report", options) : helperMissing.call(depth0, "link-to", "report", options));
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  stack1 = helpers['if'].call(depth0, "reportDataLoading", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div class=\"timeline-end\"></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["report-taskflows-delete"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "noTaskflowsToDelete", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(2, program2, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program2(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push(escapeExpression((helper = helpers['drop-tooltip-header'] || (depth0 && depth0['drop-tooltip-header']),options={hash:{
    'title': ("There's nothing to delete..."),
    'showClose': (true)
  },hashTypes:{'title': "STRING",'showClose': "BOOLEAN"},hashContexts:{'title': depth0,'showClose': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "drop-tooltip-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip-body']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  }
function program3(depth0,data) {
  
  
  data.buffer.push("You first need to tick the box to the left of each taskflow you want to delete.");
  }

function program5(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push(escapeExpression((helper = helpers['drop-tooltip-header'] || (depth0 && depth0['drop-tooltip-header']),options={hash:{
    'title': ("Sure you want to delete?"),
    'showClose': (true)
  },hashTypes:{'title': "STRING",'showClose': "BOOLEAN"},hashContexts:{'title': depth0,'showClose': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "drop-tooltip-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(8, program8, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip-body']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(8, program8, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(escapeExpression((helper = helpers['drop-tooltip-footer-delete-confirm'] || (depth0 && depth0['drop-tooltip-footer-delete-confirm']),options={hash:{
    'action': ("deleteAction")
  },hashTypes:{'action': "STRING"},hashContexts:{'action': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "drop-tooltip-footer-delete-confirm", options))));
  return buffer;
  }
function program8(depth0,data) {
  
  
  data.buffer.push("Deleting the selected taskflows is permanent and<em>&nbsp;there is no undo...</em><br /><br />Each taskflow instance's history, tasks and fields will be deleted completely.");
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["report"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<div class=\"site-view\"><div class=\"panel panel-kotive\"><div class=\"panel-heading\">");
  stack1 = (helper = helpers['link-to'] || (depth0 && depth0['link-to']),options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[depth0],types:["STRING"],data:data},helper ? helper.call(depth0, "designer.workflows", options) : helperMissing.call(depth0, "link-to", "designer.workflows", options));
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("&nbsp;&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "model.workflow.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "workflowSet", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(6, program6, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div><div class=\"panel-body\">");
  stack1 = helpers.unless.call(depth0, "model.reportLoaded", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(8, program8, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "model.reportLoaded", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(17, program17, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div></div>");
  return buffer;
  }
function program2(depth0,data) {
  
  
  data.buffer.push("<span class=\"glyphicon glyphicon-chevron-left icon-white\"></span>");
  }

function program4(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<span class=\"pull-right\"><button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "showReportColumnChooser", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" title=\"Customize the table's columns\" class=\"btn btn-success btn-sm report-column-chooser-btn\"><span class=\"glyphicon glyphicon-list-alt\"></span></button>&nbsp;<button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "createTaskflow", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-sm\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp; Start a new \"");
  stack1 = helpers._triageMustache.call(depth0, "model.workflow.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\"&nbsp; taskflow</button></span>");
  return buffer;
  }

function program8(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div class=\"text-center\">");
  stack1 = helpers['if'].call(depth0, "model.reportHeadingLoaded", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(11, program11, data),fn:self.program(9, program9, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<br />");
  stack1 = helpers['if'].call(depth0, "model.reportDataLoaded", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(15, program15, data),fn:self.program(13, program13, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  }
function program9(depth0,data) {
  
  
  data.buffer.push("<span class=\"glyphicon glyphicon-ok icon-success\"></span>&nbsp;Updated the columns");
  }

function program11(depth0,data) {
  
  
  data.buffer.push("<img src=\"/images/32201ecd.loading.gif\" />&nbsp;Updating the columns...");
  }

function program13(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<span class=\"glyphicon glyphicon-ok icon-success\"></span>&nbsp;Received the&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "model.workflow.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("&nbsp;data");
  return buffer;
  }

function program15(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<img src=\"/images/32201ecd.loading.gif\" />&nbsp;Fetching the&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "model.workflow.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("&nbsp;data...");
  return buffer;
  }

function program17(depth0,data) {
  
  
  data.buffer.push(escapeExpression(helpers.view.call(depth0, "datatable", {hash:{
    'columns': ("reportColumns"),
    'dataRows': ("dataRows"),
    'classNames': ("table table-striped table-bordered table-hover"),
    'noDataMessage': ("No tasks have been created yet"),
    'buttons': ("delete,download")
  },hashTypes:{'columns': "ID",'dataRows': "ID",'classNames': "STRING",'noDataMessage': "STRING",'buttons': "STRING"},hashContexts:{'columns': depth0,'dataRows': depth0,'classNames': depth0,'noDataMessage': depth0,'buttons': depth0},contexts:[depth0],types:["STRING"],data:data})));
  }

  stack1 = helpers['if'].call(depth0, "showReportTable", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers._triageMustache.call(depth0, "outlet", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  
});

Ember.TEMPLATES["reset"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['show-alert'] || (depth0 && depth0['show-alert']),options={hash:{
    'message': ("validationMessage")
  },hashTypes:{'message': "ID"},hashContexts:{'message': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "show-alert", options))));
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

  data.buffer.push("<div class=\"container-mini center-block\"><form><div class=\"panel panel-kotive\"><div class=\"panel-heading\"><h3>Choose your new password</h3></div><div class=\"panel-body\">");
  stack1 = helpers['if'].call(depth0, "validationErrors", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div id=\"js-api-unavailable\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":alert :alert-warning showApiAlert:shown:hidden")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><p>We're busy upgrading the server. Please try again in 10 minutes.</p></div><div class=\"form-group\"><label for=\"label\" class=\"control-label\">Your email address</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("email"),
    'class': ("form-control email-value"),
    'value': ("model.email"),
    'disabled': (true)
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID",'disabled': "BOOLEAN"},hashContexts:{'type': depth0,'class': depth0,'value': depth0,'disabled': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><div class=\"form-group\"><label for=\"label\" class=\"control-label\">Choose a new password</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("password"),
    'class': ("form-control password-value"),
    'value': ("model.password")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><div class=\"form-group\"><label for=\"label\" class=\"control-label\">Confirm your new password</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("password"),
    'class': ("form-control password-confirmation-value"),
    'value': ("model.passwordConfirmation")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><button id=\"js-reset-button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "userReset", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-lg btn-block\">Reset my password</button></div></div></form></div>");
  return buffer;
  
});

Ember.TEMPLATES["role-add"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<form role=\"form\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "save", {hash:{
    'on': ("submit")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(">");
  data.buffer.push(escapeExpression((helper = helpers['drop-tooltip-header'] || (depth0 && depth0['drop-tooltip-header']),options={hash:{
    'title': ("Add a new role"),
    'showClose': (true)
  },hashTypes:{'title': "STRING",'showClose': "BOOLEAN"},hashContexts:{'title': depth0,'showClose': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "drop-tooltip-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip-body']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(6, program6, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip-footer']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip-footer']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip-footer']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip-footer', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(6, program6, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</form>");
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div class=\"form-group\"><label>Role label</label><p class=\"help-block\">E.g. Manager, Customer, Team leader, Supplier</p>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'id': ("role-label"),
    'type': ("text"),
    'class': ("form-control title-value"),
    'value': ("model.label")
  },hashTypes:{'id': "STRING",'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'id': depth0,'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div>");
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button type=\"button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "cancel", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-default\">Cancel</button>&nbsp;<button type=\"submit\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "save", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\">Save</button>");
  return buffer;
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["role-delete"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push(escapeExpression((helper = helpers['drop-tooltip-header'] || (depth0 && depth0['drop-tooltip-header']),options={hash:{
    'title': ("Sure you want to delete?"),
    'showClose': (true)
  },hashTypes:{'title': "STRING",'showClose': "BOOLEAN"},hashContexts:{'title': depth0,'showClose': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "drop-tooltip-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip-body']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(escapeExpression((helper = helpers['drop-tooltip-footer-delete-confirm'] || (depth0 && depth0['drop-tooltip-footer-delete-confirm']),options={hash:{
    'action': ("deleteAction")
  },hashTypes:{'action': "STRING"},hashContexts:{'action': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "drop-tooltip-footer-delete-confirm", options))));
  return buffer;
  }
function program2(depth0,data) {
  
  
  data.buffer.push("<em>Deleting is permanent and there is no undo...</em>");
  }

function program4(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["role-editor"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push(escapeExpression((helper = helpers['modal-header'] || (depth0 && depth0['modal-header']),options={hash:{
    'title': ("Manage roles")
  },hashTypes:{'title': "STRING"},hashContexts:{'title': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "modal-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(8, program8, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-body']) { stack1 = blockHelperMissing.call(depth0, 'modal-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(8, program8, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(8, program8, data),fn:self.program(10, program10, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-footer']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-footer']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-footer']) { stack1 = blockHelperMissing.call(depth0, 'modal-footer', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(8, program8, data),fn:self.program(10, program10, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<table class=\"table table-striped table-hover\"><thead><tr><th colspan=\"2\">Roles in ");
  stack1 = helpers._triageMustache.call(depth0, "group.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</th></tr></thead><tbody>");
  stack1 = helpers.each.call(depth0, "role", "in", "sortedRoles", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(8, program8, data),fn:self.program(3, program3, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</tbody></table>");
  return buffer;
  }
function program3(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "role.isEditable", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(6, program6, data),fn:self.program(4, program4, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program4(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<tr ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'id': ("role.id")
  },hashTypes:{'id': "STRING"},hashContexts:{'id': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><td class=\"text text-muted\"><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "updateRole", "role", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","ID"],data:data})));
  data.buffer.push(" class=\"role cursor\">");
  stack1 = helpers._triageMustache.call(depth0, "role.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</a></td><td class=\"text-right\"><small ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "deleteRole", "role", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","ID"],data:data})));
  data.buffer.push(" class=\"role-delete cursor\"><span class=\"glyphicon glyphicon-trash\"></span></small></td></tr>");
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<tr ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'id': ("role.id")
  },hashTypes:{'id': "STRING"},hashContexts:{'id': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><td colspan=\"2\" class=\"text-muted\">");
  stack1 = helpers._triageMustache.call(depth0, "role.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("&nbsp;<mark class=\"small text-muted\">&nbsp;a default role&nbsp;</mark></td></tr>");
  return buffer;
  }

function program8(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program10(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<div class=\"pull-left\"><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "createRole", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"add-new-role-link btn btn-success btn-sm\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp;Add a new role</a></div><div class=\"pull-right\"><button id=\"js-save-field-button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "closeModal", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\"><span class=\"glyphicon glyphicon-ok\"></span>&nbsp;Done</button><div class=\"clearfix\"></div></div>");
  return buffer;
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(8, program8, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-container']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-container']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-container']) { stack1 = blockHelperMissing.call(depth0, 'modal-container', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(8, program8, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["role-update"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<form role=\"form\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "save", {hash:{
    'on': ("submit")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(">");
  data.buffer.push(escapeExpression((helper = helpers['drop-tooltip-header'] || (depth0 && depth0['drop-tooltip-header']),options={hash:{
    'title': ("Update role"),
    'showClose': (true)
  },hashTypes:{'title': "STRING",'showClose': "BOOLEAN"},hashContexts:{'title': depth0,'showClose': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "drop-tooltip-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip-body']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(6, program6, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip-footer']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip-footer']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip-footer']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip-footer', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(6, program6, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</form>");
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div class=\"form-group\"><label>Role label</label><p class=\"help-block\">E.g. Manager, Customer, Team leader, Supplier</p>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'id': ("role-label"),
    'type': ("text"),
    'class': ("form-control title-value"),
    'value': ("model.label")
  },hashTypes:{'id': "STRING",'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'id': depth0,'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div>");
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program6(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "updating", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(9, program9, data),fn:self.program(7, program7, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program7(depth0,data) {
  
  
  data.buffer.push("<img src=\"/images/32201ecd.loading.gif\" /><small class=\"text-muted\">&nbsp; Saving changes</small>");
  }

function program9(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button type=\"button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "cancel", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-default\">Cancel</button>&nbsp;<button type=\"submit\" class=\"btn btn-success\">Save</button>");
  return buffer;
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["roles-new"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("Cancel");
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

  data.buffer.push("<div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><div class=\"panel panel-kotive\"><div class=\"panel-heading\">Add a new role</div><div class=\"panel-body\"><div class=\"form-group\"><label for=\"label\" class=\"control-label\">Role label</label><p class=\"help-block\">E.g. Manager, Customer, Team leader, Supplier</p>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("label"),
    'class': ("form-control"),
    'value': ("")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "STRING"},hashContexts:{'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div></div><div class=\"panel-footer\"><div class=\"pull-right\">");
  stack1 = (helper = helpers['link-to'] || (depth0 && depth0['link-to']),options={hash:{
    'class': ("btn btn-default")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["STRING"],data:data},helper ? helper.call(depth0, "roles", options) : helperMissing.call(depth0, "link-to", "roles", options));
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("&nbsp;<button id=\"\" click=\"\" class=\"btn btn-success\">Save</button></div></div></div></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["settings"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  data.buffer.push("<div class=\"form-group\"><div class=\"checkbox\"><label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'name': ("publish"),
    'type': ("checkbox"),
    'checked': ("model.publish")
  },hashTypes:{'name': "STRING",'type': "STRING",'checked': "ID"},hashContexts:{'name': depth0,'type': depth0,'checked': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("Yes, publish this form<p class=\"help-block\">If published, you will be able to make this form available to people who are not logged-in.<br />Different ways to share this taskflow with non-logged-in people are available under the <strong>\"Taskflow settings\"</strong>&nbsp;button on the left.</p></label></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["signup"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<form>");
  data.buffer.push(escapeExpression((helper = helpers['modal-header'] || (depth0 && depth0['modal-header']),options={hash:{
    'title': ("Signup for a free Kotive account")
  },hashTypes:{'title': "STRING"},hashContexts:{'title': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "modal-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-body']) { stack1 = blockHelperMissing.call(depth0, 'modal-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(6, program6, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-footer']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-footer']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-footer']) { stack1 = blockHelperMissing.call(depth0, 'modal-footer', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(6, program6, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</form>");
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div id=\"js-signup-alert\" class=\"alert alert-warning hidden\"><p>Please enter a valid email address.</p></div><div id=\"js-api-error\" class=\"alert alert-warning hidden\"><p>We're busy upgrading the server. Please try again in 10 minutes.</p></div><div class=\"form-group\"><label for=\"label\" class=\"control-label\">Email address</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("email"),
    'class': ("form-control email-value"),
    'value': ("model.email")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div>");
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = '', stack1;
  stack1 = helpers['if'].call(depth0, "processingSignup", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(9, program9, data),fn:self.program(7, program7, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div class=\"clearfix\"></div>");
  return buffer;
  }
function program7(depth0,data) {
  
  
  data.buffer.push("<div class=\"text-center\"><img src=\"/images/32201ecd.loading.gif\" /></div>");
  }

function program9(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button id=\"js-signup-button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "submitSignup", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-block\">Create your Kotive account</button><div class=\"text-center small\"><p></p>or&nbsp;<a href=\"#/login\">login</a>&nbsp;if you already have an account.</div>");
  return buffer;
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-container']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-container']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-container']) { stack1 = blockHelperMissing.call(depth0, 'modal-container', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["something-went-wrong"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  


  data.buffer.push("<div class=\"container-small center-block\"><div class=\"panel panel-kotive\"><div class=\"panel-heading\">We're sorry, something technical has gone wrong on our side...</div><div class=\"panel-body\"><h4>What can you do?</h4><p>1. Go somewhere else by using the main menu.</p><p>2. If that doesn't work, then try again in a couple of minutes.</p><p>3. Or <a href=\"mailto:support@kotive.com\">let us know</a>.</p></div></div></div>");
  
});

Ember.TEMPLATES["switch"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("<tr><td align=\"center\"><img src=\"/images/32201ecd.loading.gif\" />&nbsp;Waiting for all taskflow information to be synced for application&nbsp;&nbsp;</td></tr>");
  }

function program3(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<thead><tr><th>Maker accounts, Apps and Organizations/Teams</th></tr></thead><tbody>");
  stack1 = helpers.each.call(depth0, "group", "in", "model", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(6, program6, data),fn:self.program(4, program4, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</tbody>");
  return buffer;
  }
function program4(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['switch-branch'] || (depth0 && depth0['switch-branch']),options={hash:{
    'group': ("group"),
    'position': (0),
    'activeGroupId': ("activeGroupId"),
    'groups': ("groups"),
    'action': ("setActive")
  },hashTypes:{'group': "ID",'position': "INTEGER",'activeGroupId': "ID",'groups': "ID",'action': "STRING"},hashContexts:{'group': depth0,'position': depth0,'activeGroupId': depth0,'groups': depth0,'action': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "switch-branch", options))));
  }

function program6(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program8(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<div class=\"panel-footer\"><div class=\"pull-right\"><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "cancel", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-chevron-left\"></span>&nbsp;Back</a></div></div>");
  return buffer;
  }

  data.buffer.push("<div class=\"container-medium center-block\"><div class=\"panel panel-kotive\"><div class=\"panel-heading\"><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "cancel", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"cursor\"><span class=\"glyphicon glyphicon-chevron-left icon-white\"></span></a>&nbsp;&nbsp;Switch to another Maker account, App or Organization/Team</div><div class=\"panel-body\"><table class=\"table table-striped table-hover valign-middle\">");
  stack1 = helpers['if'].call(depth0, "syncingApp", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</table></div>");
  stack1 = helpers.unless.call(depth0, "syncingApp", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(6, program6, data),fn:self.program(8, program8, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div>");
  return buffer;
  
});

Ember.TEMPLATES["task"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'data-field-id': ("field.id")
  },hashTypes:{'data-field-id': "STRING"},hashContexts:{'data-field-id': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":kotive-task-form-field field.visible:marked-visible:hidden")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">");
  data.buffer.push(escapeExpression((helper = helpers['draw-kotive-field'] || (depth0 && depth0['draw-kotive-field']),options={hash:{
    'model': ("field"),
    'value': ("field.value"),
    'name': ("field.label"),
    'mode': ("solution")
  },hashTypes:{'model': "ID",'value': "ID",'name': "ID",'mode': "STRING"},hashContexts:{'model': depth0,'value': depth0,'name': depth0,'mode': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "draw-kotive-field", options))));
  data.buffer.push("</div>");
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

  data.buffer.push("<div class=\"task-heading\">");
  stack1 = helpers._triageMustache.call(depth0, "task.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div><div class=\"task-body\"><div id=\"js-validation-alert\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":alert :alert-warning model.isIncomplete:shown:hidden")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><p id=\"js-validation-message\">Please ensure that all the highlighted fields have been completed. Then resubmit the form.</p></div>");
  stack1 = helpers.each.call(depth0, "field", "in", "model.fields", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["taskflow-recipes"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<form role=\"form\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "createTemplateActivity", {hash:{
    'on': ("submit")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(">");
  data.buffer.push(escapeExpression((helper = helpers['modal-header'] || (depth0 && depth0['modal-header']),options={hash:{
    'title': ("Get a quick start with a taskflow template...")
  },hashTypes:{'title': "STRING"},hashContexts:{'title': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "modal-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(11, program11, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-body']) { stack1 = blockHelperMissing.call(depth0, 'modal-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(11, program11, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(11, program11, data),fn:self.program(15, program15, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-footer']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-footer']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-footer']) { stack1 = blockHelperMissing.call(depth0, 'modal-footer', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(11, program11, data),fn:self.program(15, program15, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</form>");
  return buffer;
  }
function program2(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "loadingTemplates", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program3(depth0,data) {
  
  
  data.buffer.push("<div class=\"text-center\"><img src=\"/images/32201ecd.loading.gif\" />&nbsp;&nbsp;loading taskflow templates...</div>");
  }

function program5(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "generating", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(8, program8, data),fn:self.program(6, program6, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program6(depth0,data) {
  
  
  data.buffer.push("<div class=\"text-center\"><img src=\"/images/32201ecd.loading.gif\" />&nbsp;&nbsp;generating from template, please wait...</div>");
  }

function program8(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<strong>Choose from one of our taskflow templates...</strong><br /><p><small>The taskflow you choose will be copied into your Designer. It's a fully working template you can learn from, work with, change or use as-is - complete with tasks, fields, conditions and dynamic field tags.</small></p><div class=\"row\">");
  stack1 = helpers['if'].call(depth0, "selectedTemplate", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(11, program11, data),fn:self.program(9, program9, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers.each.call(depth0, "template", "in", "templates", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(11, program11, data),fn:self.program(13, program13, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  }
function program9(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div class=\"col-xs-4 text-center cursor taskflow-recipe selected-taskflow-recipe\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "generateFromTemplate", "selectedTemplate", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","ID"],data:data})));
  data.buffer.push("><span><img ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'src': ("selectedTemplate.image")
  },hashTypes:{'src': "STRING"},hashContexts:{'src': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" width=\"75\" class=\"img-circle img-thumbnail\" /><p><strong>");
  stack1 = helpers._triageMustache.call(depth0, "selectedTemplate.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</strong></p><small>");
  stack1 = helpers._triageMustache.call(depth0, "selectedTemplate.description", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</small></span></div>");
  return buffer;
  }

function program11(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":col-xs-4 :text-center :cursor :taskflow-recipe template.selected:hidden template.invisible:hidden")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "generateFromTemplate", "template", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","ID"],data:data})));
  data.buffer.push("><span><img ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'src': ("template.image")
  },hashTypes:{'src': "STRING"},hashContexts:{'src': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" width=\"75\" class=\"img-circle img-thumbnail\" /><p><strong>");
  stack1 = helpers._triageMustache.call(depth0, "template.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</strong></p><small>");
  stack1 = helpers._triageMustache.call(depth0, "template.description", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</small></span></div>");
  return buffer;
  }

function program15(depth0,data) {
  
  var stack1;
  stack1 = helpers.unless.call(depth0, "generating", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(11, program11, data),fn:self.program(16, program16, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program16(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "skipGenerateFromTemplate", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-default\">No thanks, I'll start on my own</a>");
  return buffer;
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(11, program11, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-container']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-container']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-container']) { stack1 = blockHelperMissing.call(depth0, 'modal-container', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(11, program11, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["taskflow"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1;


  stack1 = helpers._triageMustache.call(depth0, "outlet", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["taskflow/full"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', escapeExpression=this.escapeExpression;


  data.buffer.push("<div class=\"hub-iframe\"><iframe ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'src': ("hubUrl")
  },hashTypes:{'src': "STRING"},hashContexts:{'src': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" frameborder=\"0\" width=\"100%\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'height': ("hubHeight")
  },hashTypes:{'height': "STRING"},hashContexts:{'height': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("></iframe></div>");
  return buffer;
  
});

Ember.TEMPLATES["taskflow/lite"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "tasks", "model", options) : helperMissing.call(depth0, "render", "tasks", "model", options))));
  
});

Ember.TEMPLATES["taskflow/retry"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("<span class=\"glyphicon glyphicon-ok icon-success\"></span>&nbsp;Retried the failed task.<br /><img src=\"/images/32201ecd.loading.gif\" />&nbsp;Now retrying the taskflow...");
  }

function program3(depth0,data) {
  
  
  data.buffer.push("<img src=\"/images/32201ecd.loading.gif\" />&nbsp;Retrying the failed task...");
  }

  data.buffer.push("<div class=\"row\"><div class=\"col-xs-6 col-xs-offset-3 col-sm-4 col-sm-offset-4\"><div class=\"card-kotive\"><div class=\"card-body text-center\">");
  stack1 = helpers['if'].call(depth0, "retriedTaskflow", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["tasks"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div class=\"panel-heading\"><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "cancel", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"cursor\"><span class=\"glyphicon glyphicon-chevron-left icon-white\"></span></a>&nbsp;&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "model.workflow.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div role=\"tabpanel\" id=\"js-field-tab\"><ul role=\"tablist\" class=\"nav nav-tabs tasks-tabs\">");
  stack1 = helpers.each.call(depth0, "task", "in", "model.tasks", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(6, program6, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</ul></div>");
  return buffer;
  }
function program6(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<li role=\"presentation\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': ("task.firstTask:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><a ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'aria-controls': ("task.id")
  },hashTypes:{'aria-controls': "STRING"},hashContexts:{'aria-controls': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" id=\"js-properties\" data-toggle=\"tab\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'href': ("task.hrefId")
  },hashTypes:{'href': "STRING"},hashContexts:{'href': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" role=\"tab\">");
  stack1 = helpers._triageMustache.call(depth0, "task.abbreviatedLabel", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</a></li>");
  return buffer;
  }

function program8(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":tab-pane task.firstTask:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" role=\"tabpanel\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'id': ("task.positionId")
  },hashTypes:{'id': "STRING"},hashContexts:{'id': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">");
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "task", "task", options) : helperMissing.call(depth0, "render", "task", "task", options))));
  data.buffer.push("</div>");
  return buffer;
  }

function program10(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<div class=\"panel-body text-center\">There are currently no more tasks that you need to complete.<br /><br />");
  stack1 = (helper = helpers['link-to'] || (depth0 && depth0['link-to']),options={hash:{
    'class': ("btn btn-success")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},inverse:self.program(3, program3, data),fn:self.program(11, program11, data),contexts:[depth0],types:["STRING"],data:data},helper ? helper.call(depth0, "index", options) : helperMissing.call(depth0, "link-to", "index", options));
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  }
function program11(depth0,data) {
  
  
  data.buffer.push("<span class=\"glyphicon glyphicon-home icon-white\"></span>&nbsp; Return home");
  }

function program13(depth0,data) {
  
  var stack1;
  stack1 = helpers.unless.call(depth0, "model.requiresUserInput", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(14, program14, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program14(depth0,data) {
  
  
  data.buffer.push("<div class=\"panel-body text-center\"><img src=\"/images/32201ecd.loading.gif\" /></div>");
  }

function program16(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div class=\"panel-footer\"><div class=\"pull-right\">");
  stack1 = helpers['if'].call(depth0, "saving", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(17, program17, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers.unless.call(depth0, "saving", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(19, program19, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div>");
  return buffer;
  }
function program17(depth0,data) {
  
  
  data.buffer.push("<div class=\"saving\"><img src=\"/images/32201ecd.loading.gif\" />&nbsp;&nbsp;saving...&nbsp;</div>");
  }

function program19(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<a id=\"goBack\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "cancel", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-default\">Cancel</a>&nbsp;<button id=\"saveTask\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "save", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\">Save</button>");
  return buffer;
  }

  data.buffer.push("<div class=\"row-fluid\"><div class=\"container-small center-block\"><form id=\"js-task-form\"><div class=\"panel panel-kotive\">");
  stack1 = helpers['if'].call(depth0, "model.workflow.label", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div class=\"panel-body tasks-panel\">");
  stack1 = helpers['if'].call(depth0, "model.hasMultipleTasks", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div class=\"tab-content\">");
  stack1 = helpers.each.call(depth0, "task", "in", "model.tasks", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(8, program8, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div>");
  stack1 = helpers['if'].call(depth0, "model.hasNoTasks", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(13, program13, data),fn:self.program(10, program10, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "model.requiresUserInput", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(16, program16, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></form></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["template-activity-add"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<form role=\"form\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "createTemplateActivity", {hash:{
    'on': ("submit")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(">");
  data.buffer.push(escapeExpression((helper = helpers['modal-header'] || (depth0 && depth0['modal-header']),options={hash:{
    'title': ("Add a new task")
  },hashTypes:{'title': "STRING"},hashContexts:{'title': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "modal-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(6, program6, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-body']) { stack1 = blockHelperMissing.call(depth0, 'modal-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(6, program6, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers._triageMustache.call(depth0, "modal-footer", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</form>");
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div class=\"form-group\"><label class=\"control-label\">Select a task</label><div class=\"template-activity-type-block\">");
  stack1 = helpers['if'].call(depth0, "templateActivityTypesUpdated", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(8, program8, data),fn:self.program(3, program3, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  stack1 = helpers['if'].call(depth0, "hasTemplateActivitySubTypes", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(6, program6, data),fn:self.program(10, program10, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  stack1 = helpers['if'].call(depth0, "hasActivitySelected", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(6, program6, data),fn:self.program(12, program12, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "isFormActivity", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(6, program6, data),fn:self.program(14, program14, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  }
function program3(depth0,data) {
  
  var stack1;
  stack1 = helpers.each.call(depth0, "templateActivityType", "in", "templateActivityTypes", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(6, program6, data),fn:self.program(4, program4, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program4(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":thumb :text-center templateActivityType.name templateActivityType.disabled:disabled")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "templateActivityTypeSelected", "templateActivityType", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","ID"],data:data})));
  data.buffer.push("><img ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'src': ("templateActivityType.activityTypeIcon")
  },hashTypes:{'src': "STRING"},hashContexts:{'src': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" class=\"template-type-icons\" /><h6 class=\"text-center\">");
  stack1 = helpers._triageMustache.call(depth0, "templateActivityType.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</h6></div>");
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program8(depth0,data) {
  
  
  data.buffer.push("<small class=\"loading\">Loading tasks...</small>");
  }

function program10(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<div class=\"clearfix\"></div><div class=\"form-group\"><label class=\"control-label\">Which action?</label>");
  data.buffer.push(escapeExpression(helpers.view.call(depth0, "select", {hash:{
    'class': ("form-control field-type-selection"),
    'content': ("templateActivitySubTypes"),
    'optionValuePath': ("content.id"),
    'optionLabelPath': ("content.label"),
    'value': ("selectedTemplateActivitySubTypeId"),
    'prompt': ("Please select...")
  },hashTypes:{'class': "STRING",'content': "ID",'optionValuePath': "STRING",'optionLabelPath': "STRING",'value': "ID",'prompt': "STRING"},hashContexts:{'class': depth0,'content': depth0,'optionValuePath': depth0,'optionLabelPath': depth0,'value': depth0,'prompt': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push("</div>");
  return buffer;
  }

function program12(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div class=\"form-group\"><label for=\"title\" class=\"control-label\">Task label</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("text"),
    'class': ("form-control title-value"),
    'id': ("title"),
    'value': ("model.label")
  },hashTypes:{'type': "STRING",'class': "STRING",'id': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'id': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("hidden"),
    'id': ("kind"),
    'value': ("model.kind")
  },hashTypes:{'type': "STRING",'id': "STRING",'value': "ID"},hashContexts:{'type': depth0,'id': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div>");
  return buffer;
  }

function program14(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div class=\"form-group\"><div class=\"checkbox\"><label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'name': ("publish"),
    'type': ("checkbox"),
    'checked': ("model.publish")
  },hashTypes:{'name': "STRING",'type': "STRING",'checked': "ID"},hashContexts:{'name': depth0,'type': depth0,'checked': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("Yes, publish this form<p class=\"help-block\">If published, anonymous, non-logged-in users will be able to see and complete this form.</p></label></div></div>");
  return buffer;
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(6, program6, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-container']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-container']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-container']) { stack1 = blockHelperMissing.call(depth0, 'modal-container', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(6, program6, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["template-activity-auth-add"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push(escapeExpression((helper = helpers['modal-header'] || (depth0 && depth0['modal-header']),options={hash:{
    'title': ("addTitle")
  },hashTypes:{'title': "ID"},hashContexts:{'title': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "modal-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-body']) { stack1 = blockHelperMissing.call(depth0, 'modal-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(11, program11, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-footer']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-footer']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-footer']) { stack1 = blockHelperMissing.call(depth0, 'modal-footer', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(11, program11, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div class=\"clearfix\"></div>");
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = '', stack1;
  stack1 = helpers['if'].call(depth0, "hasErrors", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<form role=\"form\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "save", {hash:{
    'on': ("submit")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': ("hasError:has-warning")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><fieldset>");
  stack1 = helpers.each.call(depth0, "field", "in", "fields", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(7, program7, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "requiresOAuth2", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(9, program9, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</fieldset></form>");
  return buffer;
  }
function program3(depth0,data) {
  
  
  data.buffer.push("<div id=\"js-validation-alert\" class=\"alert alert-warning\"><p id=\"js-validation-message\">Please ensure that all the highlighted fields have been completed. Then resubmit the form.</p></div>");
  }

function program5(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program7(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['draw-kotive-service-field'] || (depth0 && depth0['draw-kotive-service-field']),options={hash:{
    'model': ("field"),
    'value': ("field.patternString"),
    'name': ("field.label")
  },hashTypes:{'model': "ID",'value': "ID",'name': "ID"},hashContexts:{'model': depth0,'value': depth0,'name': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "draw-kotive-service-field", options))));
  }

function program9(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['oauth2-generate'] || (depth0 && depth0['oauth2-generate']),options={hash:{
    'model': ("oauth2Field"),
    'serviceName': ("serviceName")
  },hashTypes:{'model': "ID",'serviceName': "ID"},hashContexts:{'model': depth0,'serviceName': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "oauth2-generate", options))));
  }

function program11(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "cancel", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-default\">Cancel</a>&nbsp;&nbsp;<a id=\"save\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "save", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\">Save</a>");
  return buffer;
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-container']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-container']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-container']) { stack1 = blockHelperMissing.call(depth0, 'modal-container', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["template-activity-auth"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("<div class=\"panel-body text-center\"><br /><img src=\"/images/32201ecd.loading.gif\" />&nbsp;loading existing accounts...</div>");
  }

function program3(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div class=\"panel-body\"><div class=\"row\"><div class=\"col-xs-12\">");
  stack1 = helpers['if'].call(depth0, "hasAuthRecords", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(12, program12, data),fn:self.program(4, program4, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div></div>");
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<h4>The selected ");
  stack1 = helpers._triageMustache.call(depth0, "serviceName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(" account used by this task...</h4><form><fieldset>");
  stack1 = helpers.each.call(depth0, "auth", "in", "authRecords", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(10, program10, data),fn:self.program(5, program5, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div class=\"clearfix\"></div><br /><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "createNewAuth", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success add-field-btn\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp;Connect another ");
  stack1 = helpers._triageMustache.call(depth0, "serviceName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(" account</a></fieldset></form>");
  return buffer;
  }
function program5(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div class=\"radio\"><label ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "authSelected", "auth", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","ID"],data:data})));
  data.buffer.push(">");
  stack1 = helpers['if'].call(depth0, "auth.isActiveAuth", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(8, program8, data),fn:self.program(6, program6, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers._triageMustache.call(depth0, "auth.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</label></div>");
  return buffer;
  }
function program6(depth0,data) {
  
  
  data.buffer.push("<input type=\"radio\" name=\"auths-selection\" checked=\"checked\" />");
  }

function program8(depth0,data) {
  
  
  data.buffer.push("<input type=\"radio\" name=\"auths-selection\" />");
  }

function program10(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program12(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div class=\"text-center\"><p><img ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'src': ("serviceIcon")
  },hashTypes:{'src': "STRING"},hashContexts:{'src': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" /><br />No&nbsp;<strong>");
  stack1 = helpers._triageMustache.call(depth0, "serviceName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(" account</strong>&nbsp;has been connected yet…<br /><em>You'll need to connect one before this taskflow can be run.</em><br /></p><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "createNewAuth", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success add-field-btn\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp;Connect your ");
  stack1 = helpers._triageMustache.call(depth0, "serviceName", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(" account now</a></div>");
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, "loading", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["template-activity-delete"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "cannotDeleteTask", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(2, program2, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program2(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push(escapeExpression((helper = helpers['drop-tooltip-header'] || (depth0 && depth0['drop-tooltip-header']),options={hash:{
    'title': ("You cannot delete this task..."),
    'showClose': (true)
  },hashTypes:{'title': "STRING",'showClose': "BOOLEAN"},hashContexts:{'title': depth0,'showClose': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "drop-tooltip-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip-body']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  }
function program3(depth0,data) {
  
  
  data.buffer.push("You need to delete all the tasks in this sub-taskflow before you can delete the sub-taskflow.");
  }

function program5(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push(escapeExpression((helper = helpers['drop-tooltip-header'] || (depth0 && depth0['drop-tooltip-header']),options={hash:{
    'title': ("Sure you want to delete?"),
    'showClose': (true)
  },hashTypes:{'title': "STRING",'showClose': "BOOLEAN"},hashContexts:{'title': depth0,'showClose': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "drop-tooltip-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(8, program8, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip-body']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(8, program8, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(escapeExpression((helper = helpers['drop-tooltip-footer-delete-confirm'] || (depth0 && depth0['drop-tooltip-footer-delete-confirm']),options={hash:{
    'action': ("deleteAction")
  },hashTypes:{'action': "STRING"},hashContexts:{'action': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "drop-tooltip-footer-delete-confirm", options))));
  return buffer;
  }
function program8(depth0,data) {
  
  
  data.buffer.push("Deleting this task, its fields and conditions is permanent and<em>&nbsp;there is no undo...</em>");
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["template-activity-form"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("<div class=\"panel-body text-center\">Get started by adding your first field</div>");
  }

function program3(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<div class=\"panel-body template-activity-editor-body\"><div role=\"tabpanel\" id=\"js-field-tab\"><ul role=\"tablist\" class=\"nav nav-tabs\"><li role=\"presentation\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "formTabActivated", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': ("mainSelected:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><a aria-controls=\"properties\" id=\"js-properties\" data-toggle=\"tab\" href=\"#properties\" role=\"tab\"><img ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'src': ("taskIcon")
  },hashTypes:{'src': "STRING"},hashContexts:{'src': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" height=\"16\" width=\"16\" />&nbsp;&nbsp;Form</a></li><li role=\"presentation\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "conditionsTabActivated", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': ("conditionsSelected:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><a aria-controls=\"conditions\" id=\"js-conditions\" data-toggle=\"tab\" href=\"#conditions\" role=\"tab\"><span aria-hidden=\"true\" class=\"glyphicon glyphicon-random\"></span>&nbsp;&nbsp;Conditions</a></li><li role=\"presentation\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "settingsTabActivated", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': ("settingsSelected:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><a aria-controls=\"settings\" id=\"js-settings\" data-toggle=\"tab\" href=\"#settings\" role=\"tab\"><span aria-hidden=\"true\" class=\"glyphicon glyphicon-cog\"></span>&nbsp;&nbsp;Settings</a></li></ul><div class=\"tab-content\"><div id=\"properties\" role=\"tabpanel\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":tab-pane mainSelected:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><form><fieldset class=\"sortable\">");
  stack1 = helpers.each.call(depth0, "templateField", "in", "orderedTemplateFields", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(6, program6, data),fn:self.program(4, program4, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</fieldset></form></div><div id=\"conditions\" role=\"tabpanel\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":tab-pane conditionsSelected:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">");
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "condition", "model", options) : helperMissing.call(depth0, "render", "condition", "model", options))));
  data.buffer.push("</div><div id=\"settings\" role=\"tabpanel\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":tab-pane settingsSelected:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">");
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "settings", "model", options) : helperMissing.call(depth0, "render", "settings", "model", options))));
  data.buffer.push("</div></div></div></div>");
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'data-field-id': ("templateField.id")
  },hashTypes:{'data-field-id': "STRING"},hashContexts:{'data-field-id': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "templateFieldEdit", "templateField", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","ID"],data:data})));
  data.buffer.push(" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":kotive-template-activity-form-field templateField.visible:marked-visible:marked-invisible")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">");
  data.buffer.push(escapeExpression((helper = helpers['draw-kotive-field'] || (depth0 && depth0['draw-kotive-field']),options={hash:{
    'model': ("templateField"),
    'mode': ("designer"),
    'value': ("templateField.patternString"),
    'name': ("templateField.label"),
    'store': ("store")
  },hashTypes:{'model': "ID",'mode': "STRING",'value': "ID",'name': "ID",'store': "ID"},hashContexts:{'model': depth0,'mode': depth0,'value': depth0,'name': depth0,'store': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "draw-kotive-field", options))));
  data.buffer.push("</div>");
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program8(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<div class=\"pull-right\"><button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "addNewTemplateField", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success add-field-btn\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp;Add a new field</button></div>");
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, "noFields", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div class=\"panel-footer\">");
  stack1 = helpers['if'].call(depth0, "formTabActive", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(6, program6, data),fn:self.program(8, program8, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div class=\"clearfix\"></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["template-activity-service"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<li role=\"presentation\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': ("mainSelected:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><a aria-controls=\"properties\" data-toggle=\"tab\" href=\"#properties\" role=\"tab\"><img ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'src': ("serviceIcon")
  },hashTypes:{'src': "STRING"},hashContexts:{'src': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" height=\"16\" width=\"16\" />&nbsp;&nbsp;");
  stack1 = helpers._triageMustache.call(depth0, "serviceNameCapitalised", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</a></li>");
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<li role=\"presentation\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': ("settingsSelected:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><a aria-controls=\"settings\" id=\"js-settings\" data-toggle=\"tab\" href=\"#settings\" role=\"tab\"><span aria-hidden=\"true\" class=\"glyphicon glyphicon-cog\"></span>&nbsp;&nbsp;Settings</a></li>");
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<li role=\"presentation\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': ("authenticationSelected:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><a aria-controls=\"authentication\" data-toggle=\"tab\" href=\"#authentication\" role=\"tab\"><span aria-hidden=\"true\" class=\"glyphicon glyphicon-globe\"></span>&nbsp;&nbsp;Account details</a></li>");
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div id=\"properties\" role=\"tabpanel\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":tab-pane mainSelected:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><br /><mark class=\"small text-muted\"><strong>&nbsp;Did you know?</strong>&nbsp;You can type a curly bracket<strong>&nbsp;{&nbsp;</strong>in any field below to<a href=\"https://www.kotive.com/how-to/add-dynamic-field-tags/\" target=\"_blank\">&nbsp;pull-in field values</a>&nbsp;from earlier tasks.</mark><div class=\"clearfix\"></div><form><fieldset>");
  stack1 = helpers.each.call(depth0, "templateField", "in", "orderedTemplateFields", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(10, program10, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</fieldset></form></div>");
  return buffer;
  }
function program10(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div class=\"kotive-template-activity-service-field\">");
  data.buffer.push(escapeExpression((helper = helpers['draw-kotive-service-field'] || (depth0 && depth0['draw-kotive-service-field']),options={hash:{
    'model': ("templateField"),
    'mode': ("designer"),
    'value': ("templateField.patternString"),
    'prompt': ("prompt"),
    'store': ("store"),
    'workflow': ("workflow"),
    'templateActivity': ("templateActivity")
  },hashTypes:{'model': "ID",'mode': "STRING",'value': "ID",'prompt': "ID",'store': "ID",'workflow': "ID",'templateActivity': "ID"},hashContexts:{'model': depth0,'mode': depth0,'value': depth0,'prompt': depth0,'store': depth0,'workflow': depth0,'templateActivity': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "draw-kotive-service-field", options))));
  data.buffer.push("</div>");
  return buffer;
  }

function program12(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div id=\"settings\" role=\"tabpanel\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":tab-pane settingsSelected:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">");
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "settings", "model", options) : helperMissing.call(depth0, "render", "settings", "model", options))));
  data.buffer.push("</div>");
  return buffer;
  }

function program14(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div id=\"authentication\" role=\"tabpanel\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":tab-pane authenticationSelected:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">");
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-activity-auth", "model", options) : helperMissing.call(depth0, "render", "template-activity-auth", "model", options))));
  data.buffer.push("</div>");
  return buffer;
  }

  data.buffer.push("<div class=\"panel-body template-activity-editor-body\"><div role=\"tabpanel\" id=\"js-field-tab\"><ul role=\"tablist\" class=\"nav nav-tabs\">");
  stack1 = helpers.unless.call(depth0, "isSubTaskflow", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<li role=\"presentation\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': ("isSubTaskFlowOrConditionsSelected:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><a aria-controls=\"conditions\" data-toggle=\"tab\" href=\"#conditions\" role=\"tab\"><span aria-hidden=\"true\" class=\"glyphicon glyphicon-random\"></span>&nbsp;&nbsp;Conditions</a></li>");
  stack1 = helpers['if'].call(depth0, "showSettings", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "showAccountDetails", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(7, program7, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</ul><div class=\"tab-content\">");
  stack1 = helpers.unless.call(depth0, "isSubTaskflow", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(9, program9, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div id=\"conditions\" ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":tab-pane isSubTaskFlowOrConditionsSelected:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" role=\"tabpanel\">");
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "condition", "model", options) : helperMissing.call(depth0, "render", "condition", "model", options))));
  data.buffer.push("</div>");
  stack1 = helpers['if'].call(depth0, "showSettings", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(12, program12, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "showAccountDetails", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(14, program14, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div></div><div class=\"panel-footer\"></div>");
  return buffer;
  
});

Ember.TEMPLATES["template-activity"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("<span class=\"glyphicon glyphicon-chevron-left icon-white\"></span>");
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div class=\"inline\"><div class=\"form-inline\"><div class=\"form-group\">");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("text"),
    'class': ("form-control task-label-edit"),
    'value': ("updatedLabel")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("&nbsp; <button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "updateTaskLabel", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-sm\"><span class=\"glyphicon glyphicon-ok icon-white\"></span>&nbsp;&nbsp;Save</button><button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "editTaskLabelCancel", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-link btn-sm\"><span class=\"glyphicon glyphicon-remove icon-white cursor\"></span></button></div></div></div>");
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = '', stack1;
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "editTaskLabel", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-link btn-sm\"><span class=\"glyphicon glyphicon-pencil icon-white cursor\"></span></button>");
  return buffer;
  }

function program9(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-activity-form", "model", options) : helperMissing.call(depth0, "render", "template-activity-form", "model", options))));
  }

function program11(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-activity-service", "model", options) : helperMissing.call(depth0, "render", "template-activity-service", "model", options))));
  }

  data.buffer.push("<div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":template-activity-editor :col-md-6 showActivityEditor:show:hidden")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><div class=\"panel panel-kotive\"><div class=\"panel-heading\">");
  stack1 = (helper = helpers['link-to'] || (depth0 && depth0['link-to']),options={hash:{
    'class': ("visible-xs-inline")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["STRING"],data:data},helper ? helper.call(depth0, "workflow", options) : helperMissing.call(depth0, "link-to", "workflow", options));
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("&nbsp;&nbsp;");
  stack1 = helpers['if'].call(depth0, "editingLabel", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<span class=\"pull-right\"><button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "deleteTask", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-link btn-sm delete-task-btn\"><span class=\"glyphicon glyphicon-trash icon-white cursor\"></span></button></span></div>");
  stack1 = helpers['if'].call(depth0, "isFormActivity", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(11, program11, data),fn:self.program(9, program9, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div>");
  stack1 = helpers._triageMustache.call(depth0, "outlet", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  
});

Ember.TEMPLATES["template-field-add"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<form role=\"form\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "saveField", {hash:{
    'on': ("submit")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" id=\"template-field-add-form\">");
  data.buffer.push(escapeExpression((helper = helpers['modal-header'] || (depth0 && depth0['modal-header']),options={hash:{
    'title': ("Add a new field")
  },hashTypes:{'title': "STRING"},hashContexts:{'title': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "modal-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-body']) { stack1 = blockHelperMissing.call(depth0, 'modal-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(32, program32, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-footer']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-footer']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-footer']) { stack1 = blockHelperMissing.call(depth0, 'modal-footer', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(32, program32, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("<div class=\"clearfix\"></div></form>");
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<div class=\"form-group\"><label for=\"pattern\" class=\"control-label\">Type of field</label>");
  data.buffer.push(escapeExpression((helper = helpers['kotive-chosen-select'] || (depth0 && depth0['kotive-chosen-select']),options={hash:{
    'classes': ("form-control field-type-selection"),
    'options': ("orderedTemplateFieldTypes"),
    'selectedKey': ("selectedFieldKind")
  },hashTypes:{'classes': "STRING",'options': "ID",'selectedKey': "ID"},hashContexts:{'classes': depth0,'options': depth0,'selectedKey': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-chosen-select", options))));
  data.buffer.push("</div>");
  stack1 = helpers['if'].call(depth0, "showLabelEditField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "headingField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(7, program7, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "sectionField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(9, program9, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "paragraphField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(11, program11, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "submitField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(13, program13, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "singleSelectField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(15, program15, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "multipleSelectField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(17, program17, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "radioCheckField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(19, program19, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "uploadshowField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(21, program21, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "showFieldEditableOptions", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(23, program23, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "showDefaultValueInput", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(25, program25, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "showLabelEditField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(30, program30, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  }
function program3(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div class=\"form-group\"><label for=\"label\" class=\"control-label\">Field label</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("text"),
    'class': ("form-control label-value"),
    'value': ("model.label")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div>");
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program7(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-heading", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-heading", "model", options))));
  }

function program9(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-section", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-section", "model", options))));
  }

function program11(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-paragraph", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-paragraph", "model", options))));
  }

function program13(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-submit", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-submit", "model", options))));
  }

function program15(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-single-options", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-single-options", "model", options))));
  }

function program17(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-multiple-options", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-multiple-options", "model", options))));
  }

function program19(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-radio-check", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-radio-check", "model", options))));
  }

function program21(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-uploadshow", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-uploadshow", "model", options))));
  }

function program23(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div class=\"form-group\"><label class=\"control-label\">This field is...</label><div class=\"clearfix\"></div><label class=\"checkbox-inline\">");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("checkbox"),
    'checked': ("model.required")
  },hashTypes:{'type': "STRING",'checked': "ID"},hashContexts:{'type': depth0,'checked': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("Required</label><label class=\"checkbox-inline\">");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("checkbox"),
    'checked': ("model.readonly")
  },hashTypes:{'type': "STRING",'checked': "ID"},hashContexts:{'type': depth0,'checked': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("Read-only</label><label class=\"checkbox-inline\">");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("checkbox"),
    'checked': ("model.visible")
  },hashTypes:{'type': "STRING",'checked': "ID"},hashContexts:{'type': depth0,'checked': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("Visible</label></div>");
  return buffer;
  }

function program25(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div class=\"form-group\"><label for=\"fieldDefaultValue\" class=\"control-label\">Predefined value</label><p class=\"help-block\">The field's value will be prefilled-in with the following...<br /><mark class=\"text-muted\"><strong>TIP:</strong>&nbsp;Type a curly bracket<strong>&nbsp;{&nbsp;</strong>to <a href=\"https://www.kotive.com/how-to/add-dynamic-field-tags/\" target=\"_blank\">pull-in field values from earlier tasks.</a></mark></p>");
  stack1 = helpers['if'].call(depth0, "defaultStringValue", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(28, program28, data),fn:self.program(26, program26, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  }
function program26(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['atwho-field'] || (depth0 && depth0['atwho-field']),options={hash:{
    'value': ("model.patternString"),
    'classes': ("form-control"),
    'workflow': ("workflow"),
    'field': ("model"),
    'templateActivity': ("templateActivity"),
    'store': ("store")
  },hashTypes:{'value': "ID",'classes': "STRING",'workflow': "ID",'field': "ID",'templateActivity': "ID",'store': "ID"},hashContexts:{'value': depth0,'classes': depth0,'workflow': depth0,'field': depth0,'templateActivity': depth0,'store': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "atwho-field", options))));
  }

function program28(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['atwho-field'] || (depth0 && depth0['atwho-field']),options={hash:{
    'value': ("model.patternString"),
    'classes': ("form-control textarea"),
    'workflow': ("workflow"),
    'field': ("model"),
    'templateActivity': ("templateActivity"),
    'store': ("store"),
    'rows': ("3")
  },hashTypes:{'value': "ID",'classes': "STRING",'workflow': "ID",'field': "ID",'templateActivity': "ID",'store': "ID",'rows': "STRING"},hashContexts:{'value': depth0,'classes': depth0,'workflow': depth0,'field': depth0,'templateActivity': depth0,'store': depth0,'rows': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "atwho-field", options))));
  }

function program30(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div class=\"form-group\"><label for=\"label\" class=\"control-label\">Help text</label><p class=\"help-block\">Give people guidance or instructions related to this field</p>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("text"),
    'class': ("form-control"),
    'value': ("helptext")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div>");
  return buffer;
  }

function program32(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<a id=\"save-and-next\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "saveFieldAndAddNext", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\">Save &amp; add next</a>&nbsp;&nbsp;<button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "saveField", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" id=\"js-save-field-button\" class=\"btn btn-success\">Save</button>");
  return buffer;
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-container']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-container']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-container']) { stack1 = blockHelperMissing.call(depth0, 'modal-container', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["template-field-delete"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push(escapeExpression((helper = helpers['drop-tooltip-header'] || (depth0 && depth0['drop-tooltip-header']),options={hash:{
    'title': ("Sure you want to delete?"),
    'showClose': (true)
  },hashTypes:{'title': "STRING",'showClose': "BOOLEAN"},hashContexts:{'title': depth0,'showClose': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "drop-tooltip-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip-body']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(escapeExpression((helper = helpers['drop-tooltip-footer-delete-confirm'] || (depth0 && depth0['drop-tooltip-footer-delete-confirm']),options={hash:{
    'action': ("deleteAction")
  },hashTypes:{'action': "STRING"},hashContexts:{'action': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "drop-tooltip-footer-delete-confirm", options))));
  return buffer;
  }
function program2(depth0,data) {
  
  
  data.buffer.push("<em>Deleting is permanent and there is no undo...</em>");
  }

function program4(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["template-field-editor-heading"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  data.buffer.push("<div class=\"form-group\"><label for=\"fieldDefaultValue\" class=\"control-label\">Heading</label><p class=\"help-block\"><mark class=\"text-muted\"><strong>TIP:</strong>&nbsp;Type a curly bracket<strong>&nbsp;{&nbsp;</strong>to <a href=\"https://www.kotive.com/how-to/add-dynamic-field-tags/\" target=\"_blank\">pull-in field values from earlier tasks.</a></mark></p>");
  data.buffer.push(escapeExpression((helper = helpers['atwho-field'] || (depth0 && depth0['atwho-field']),options={hash:{
    'value': ("model.patternString"),
    'classes': ("form-control"),
    'field': ("model"),
    'store': ("store"),
    'workflow': ("workflow"),
    'templateActivity': ("templateActivity")
  },hashTypes:{'value': "ID",'classes': "STRING",'field': "ID",'store': "ID",'workflow': "ID",'templateActivity': "ID"},hashContexts:{'value': depth0,'classes': depth0,'field': depth0,'store': depth0,'workflow': depth0,'templateActivity': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "atwho-field", options))));
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["template-field-editor-multiple-options"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div class=\"row\"><div class=\"col-md-8\"><label class=\"control-label\">Options: custom</label><p class=\"help-block\">Set your custom list of options</p></div><div class=\"col-md-4\"><div class=\"pull-right\"><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "setPredefinedOptions", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-random\"></span>&nbsp;&nbsp;Switch to predefined options</a></div></div></div><ul class=\"field-options-list sortable\">");
  stack1 = helpers.each.call(depth0, "option", "in", "options", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(2, program2, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</ul>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a id=\"add-option-button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "addOption", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-sm\"><span class=\"glyhpicon glyphicon-plus\"></span>&nbsp;Add another option</a>");
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<li ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'data-field-index': ("option.index")
  },hashTypes:{'data-field-index': "STRING"},hashContexts:{'data-field-index': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" class=\"template-field-option\">");
  stack1 = (helper = helpers['kotive-check'] || (depth0 && depth0['kotive-check']),options={hash:{
    'disabled': ("model.readonly"),
    'checkedVals': ("defaultOptions"),
    'action': ("checkedDefault"),
    'value': ("option.index"),
    'name': ("default-options")
  },hashTypes:{'disabled': "ID",'checkedVals': "ID",'action': "STRING",'value': "ID",'name': "STRING"},hashContexts:{'disabled': depth0,'checkedVals': depth0,'action': depth0,'value': depth0,'name': depth0},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-check", options));
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("text"),
    'class': ("form-control input-sm radio-check-options-in-designer"),
    'value': ("option.key")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("&nbsp;<span class=\"glyphicon glyphicon-move cursor draggable-handle\"></span>&nbsp;&nbsp;&nbsp;<span ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "removeOptionAtIndex", "option.index", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","ID"],data:data})));
  data.buffer.push(" class=\"glyphicon glyphicon-trash cursor\"></span></li>");
  return buffer;
  }
function program3(depth0,data) {
  
  var stack1;
  stack1 = helpers._triageMustache.call(depth0, "option.index", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }

function program5(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program7(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-predefined-options", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-predefined-options", "model", options))));
  }

  data.buffer.push("<div class=\"form-group\"><div class=\"field-options-container\">");
  stack1 = helpers['if'].call(depth0, "showCustomOptionsType", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div>");
  return buffer;
  
});

Ember.TEMPLATES["template-field-editor-paragraph"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  data.buffer.push("<div class=\"form-group\"><label for=\"fieldDefaultValue\" class=\"control-label\">Paragraph text</label><p class=\"help-block\"><mark class=\"text-muted\"><strong>TIP:</strong>&nbsp;Type a curly bracket<strong>&nbsp;{&nbsp;</strong>to <a href=\"https://www.kotive.com/how-to/add-dynamic-field-tags/\" target=\"_blank\">pull-in field values from earlier tasks.</a></mark></p>");
  data.buffer.push(escapeExpression((helper = helpers['atwho-field'] || (depth0 && depth0['atwho-field']),options={hash:{
    'value': ("model.patternString"),
    'classes': ("form-control"),
    'rows': ("3"),
    'field': ("model"),
    'store': ("store"),
    'workflow': ("workflow"),
    'templateActivity': ("templateActivity")
  },hashTypes:{'value': "ID",'classes': "STRING",'rows': "STRING",'field': "ID",'store': "ID",'workflow': "ID",'templateActivity': "ID"},hashContexts:{'value': depth0,'classes': depth0,'rows': depth0,'field': depth0,'store': depth0,'workflow': depth0,'templateActivity': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "atwho-field", options))));
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["template-field-editor-predefined-options"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<div class=\"form-group\"><label class=\"control-label\">Select the field to be displayed in the options</label>");
  data.buffer.push(escapeExpression(helpers.view.call(depth0, "select", {hash:{
    'value': ("fieldOptSelection"),
    'content': ("fieldOptions"),
    'optionLabelPath': ("content.value"),
    'optionValuePath': ("content.key"),
    'class': ("chosen-select form-control"),
    'optionGroupPath': ("taskflowName")
  },hashTypes:{'value': "ID",'content': "ID",'optionLabelPath': "STRING",'optionValuePath': "STRING",'class': "STRING",'optionGroupPath': "STRING"},hashContexts:{'value': depth0,'content': depth0,'optionLabelPath': depth0,'optionValuePath': depth0,'class': depth0,'optionGroupPath': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push("</div>");
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

  data.buffer.push("<div class=\"row\"><div class=\"col-md-8\"><label class=\"control-label\">Options: predefined</label><p class=\"help-block\">The list of people, organizations/teams, roles and contacts in these options will be limited to the organization/team in which this taskflow’s data is being captured</p></div><div class=\"col-md-4\"><div class=\"pull-right\"><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "setCustomOptions", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-random\"></span>&nbsp;&nbsp;Switch to custom options</a></div></div></div><div class=\"form-group\">");
  data.buffer.push(escapeExpression(helpers.view.call(depth0, "select", {hash:{
    'value': ("optSelection"),
    'content': ("predefinedOptions"),
    'optionLabelPath': ("content.value"),
    'optionValuePath': ("content.key"),
    'optionGroupPath': ("grouping"),
    'class': ("chosen-select form-control")
  },hashTypes:{'value': "ID",'content': "ID",'optionLabelPath': "STRING",'optionValuePath': "STRING",'optionGroupPath': "STRING",'class': "STRING"},hashContexts:{'value': depth0,'content': depth0,'optionLabelPath': depth0,'optionValuePath': depth0,'optionGroupPath': depth0,'class': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push("</div>");
  stack1 = helpers['if'].call(depth0, "showFieldSelector", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  
});

Ember.TEMPLATES["template-field-editor-radio-check"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  data.buffer.push("<div class=\"form-group\"><label class=\"control-label\">Display these options...</label><div class=\"clearfix\"></div><label class=\"radio-inline\">");
  data.buffer.push(escapeExpression((helper = helpers['radio-button'] || (depth0 && depth0['radio-button']),options={hash:{
    'value': ("horizontal"),
    'name': ("display-type"),
    'selection': ("displayType")
  },hashTypes:{'value': "STRING",'name': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'name': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "radio-button", options))));
  data.buffer.push("Horizontal</label><label class=\"radio-inline\">");
  data.buffer.push(escapeExpression((helper = helpers['radio-button'] || (depth0 && depth0['radio-button']),options={hash:{
    'value': ("vertical"),
    'name': ("display-type"),
    'selection': ("displayType")
  },hashTypes:{'value': "STRING",'name': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'name': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "radio-button", options))));
  data.buffer.push("Vertical</label></div>");
  return buffer;
  
});

Ember.TEMPLATES["template-field-editor-section"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  data.buffer.push("<div class=\"form-group\"><label for=\"fieldDefaultValue\" class=\"control-label\">Form section title</label><p class=\"help-block\">Any fields below this form section field will be grouped together and become available under a clickable tab.<br /><em>Great for when you have a very long form with various parts!</em><br /><mark class=\"text-muted\"><strong>TIP:</strong>&nbsp;You can include <a href=\"https://semantic-ui.com/elements/icon.html\" target=\"_blank\">html icons</a>&nbsp;and&nbsp;<a href=\"https://www.emojicopy.com\" target=\"_blank\">emojis 😜</a>&nbsp;in your section's title.</mark></p>");
  data.buffer.push(escapeExpression((helper = helpers['atwho-field'] || (depth0 && depth0['atwho-field']),options={hash:{
    'value': ("model.patternString"),
    'classes': ("form-control"),
    'field': ("model"),
    'store': ("store"),
    'workflow': ("workflow"),
    'templateActivity': ("templateActivity")
  },hashTypes:{'value': "ID",'classes': "STRING",'field': "ID",'store': "ID",'workflow': "ID",'templateActivity': "ID"},hashContexts:{'value': depth0,'classes': depth0,'field': depth0,'store': depth0,'workflow': depth0,'templateActivity': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "atwho-field", options))));
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["template-field-editor-single-options"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div class=\"row\"><div class=\"col-md-8\"><label class=\"control-label\">Options: custom</label><p class=\"help-block\">Set your custom list of options</p></div><div class=\"col-md-4\"><div class=\"pull-right\"><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "setPredefinedOptions", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-random\"></span>&nbsp;&nbsp;Switch to predefined options</a></div></div></div><ul class=\"field-options-list sortable\">");
  stack1 = helpers.each.call(depth0, "option", "in", "options", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</ul>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a id=\"add-option-button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "addOption", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-sm\"><i class=\"glyhpicon glyphicon-plus\"></i>&nbsp;Add another option</a>");
  stack1 = helpers['if'].call(depth0, "hasDefault", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(6, program6, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<li ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'data-field-index': ("option.index")
  },hashTypes:{'data-field-index': "STRING"},hashContexts:{'data-field-index': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" class=\"template-field-option\">");
  data.buffer.push(escapeExpression((helper = helpers['radio-button'] || (depth0 && depth0['radio-button']),options={hash:{
    'value': ("option.index"),
    'name': ("default-option"),
    'selection': ("defaultIndex")
  },hashTypes:{'value': "ID",'name': "STRING",'selection': "ID"},hashContexts:{'value': depth0,'name': depth0,'selection': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "radio-button", options))));
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("text"),
    'class': ("form-control input-sm radio-check-options-in-designer"),
    'value': ("option.key")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("&nbsp;<span class=\"glyphicon glyphicon-move cursor draggable-handle\"></span>&nbsp;&nbsp;&nbsp;<span ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "removeOptionAtIndex", "option.index", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","ID"],data:data})));
  data.buffer.push(" class=\"glyphicon glyphicon-trash cursor\"></span></li>");
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<div class=\"clearfix\"></div><br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "clearDefaultOption", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;Clear default option</button>");
  return buffer;
  }

function program8(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-predefined-options", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-predefined-options", "model", options))));
  }

  data.buffer.push("<div class=\"form-group\"><div class=\"field-options-container\">");
  stack1 = helpers['if'].call(depth0, "showCustomOptionsType", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(8, program8, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div>");
  return buffer;
  
});

Ember.TEMPLATES["template-field-editor-submit"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, escapeExpression=this.escapeExpression;


  data.buffer.push("<div class=\"form-group\"><label class=\"control-label col-sm-2\">Style</label><div class=\"col-sm-10\"><span ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":button-wrapper selectedStyleDefault:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "setButtonStyle", "default", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-default\">");
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</button></span><span ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":button-wrapper selectedStylePrimary:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "setButtonStyle", "primary", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-primary\">");
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</button></span>&nbsp;<span ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":button-wrapper selectedStyleSuccess:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "setButtonStyle", "success", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\">");
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</button></span>&nbsp;<span ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":button-wrapper selectedStyleInfo:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "setButtonStyle", "info", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-info\">");
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</button></span>&nbsp;<span ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":button-wrapper selectedStyleWarning:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "setButtonStyle", "warning", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-warning\">");
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</button></span>&nbsp;<span ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":button-wrapper selectedStyleDanger:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "setButtonStyle", "danger", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-danger\">");
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</button></span>&nbsp;<span ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":button-wrapper selectedStyleLink:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><button onclick=\"javascript:return true;\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "setButtonStyle", "link", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data})));
  data.buffer.push(" class=\"btn-link\">");
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</button></span>&nbsp;<span ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":button-wrapper selectedStyleNoClass:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "setButtonStyle", "", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data})));
  data.buffer.push(" class=\"btn\">");
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</button></span></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Alignment</label><div class=\"col-sm-10\"><span ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":button-wrapper :cursor selectedStyleAlignLeft:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><span ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "setButtonAlignment", "left", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data})));
  data.buffer.push(" class=\"glyphicon glyphicon-align-left\"></span></span><span ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":button-wrapper :cursor selectedStyleAlignCentre:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><span ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "setButtonAlignment", "", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data})));
  data.buffer.push(" class=\"glyphicon glyphicon-align-center\"></span></span><span ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":button-wrapper :cursor selectedStyleAlignRight:active")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><span ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "setButtonAlignment", "right", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data})));
  data.buffer.push(" class=\"glyphicon glyphicon-align-right\"></span></span></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["template-field-editor-uploadshow"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['kotive-chosen-select'] || (depth0 && depth0['kotive-chosen-select']),options={hash:{
    'classes': ("form-control"),
    'options': ("uploadFieldOptions"),
    'selectedKey': ("model.patternString")
  },hashTypes:{'classes': "STRING",'options': "ID",'selectedKey': "ID"},hashContexts:{'classes': depth0,'options': depth0,'selectedKey': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-chosen-select", options))));
  }

function program3(depth0,data) {
  
  
  data.buffer.push("<p class=\"help-block\">No upload fields exist in any of the other tasks in this taskflow...</p>");
  }

  data.buffer.push("<div class=\"form-group\"><label class=\"control-label\">Which field's files should be retrieved and shown?</label>");
  stack1 = helpers['if'].call(depth0, "hasUploadFields", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["template-field"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<form role=\"form\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "createTemplateActivity", {hash:{
    'on': ("submit")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" id=\"template-field-form\">");
  data.buffer.push(escapeExpression((helper = helpers['modal-header'] || (depth0 && depth0['modal-header']),options={hash:{
    'title': ("Update this field")
  },hashTypes:{'title': "STRING"},hashContexts:{'title': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "modal-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-body']) { stack1 = blockHelperMissing.call(depth0, 'modal-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(32, program32, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-footer']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-footer']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-footer']) { stack1 = blockHelperMissing.call(depth0, 'modal-footer', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(32, program32, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</form>");
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<div class=\"form-group\"><fieldset><div class=\"form-group\"><label for=\"fieldType\" class=\"control-label\">Type of field</label>");
  data.buffer.push(escapeExpression((helper = helpers['kotive-chosen-select'] || (depth0 && depth0['kotive-chosen-select']),options={hash:{
    'classes': ("form-control field-type-selection"),
    'options': ("orderedTemplateFieldTypes"),
    'selectedKey': ("selectedFieldKind")
  },hashTypes:{'classes': "STRING",'options': "ID",'selectedKey': "ID"},hashContexts:{'classes': depth0,'options': depth0,'selectedKey': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "kotive-chosen-select", options))));
  data.buffer.push("</div>");
  stack1 = helpers['if'].call(depth0, "showLabelEditField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "headingField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(7, program7, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "sectionField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(9, program9, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "paragraphField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(11, program11, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "submitField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(13, program13, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "singleSelectField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(15, program15, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "multipleSelectField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(17, program17, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "radioCheckField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(19, program19, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "uploadshowField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(21, program21, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "showFieldEditableOptions", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(23, program23, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "showDefaultValueInput", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(25, program25, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers['if'].call(depth0, "showLabelEditField", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(30, program30, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</fieldset></div>");
  return buffer;
  }
function program3(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div class=\"form-group\"><label for=\"label\" class=\"control-label\">Field label</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("text"),
    'class': ("form-control label-value"),
    'value': ("model.label"),
    'name': ("label")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID",'name': "STRING"},hashContexts:{'type': depth0,'class': depth0,'value': depth0,'name': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div>");
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program7(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-heading", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-heading", "model", options))));
  }

function program9(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-section", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-section", "model", options))));
  }

function program11(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-paragraph", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-paragraph", "model", options))));
  }

function program13(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-submit", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-submit", "model", options))));
  }

function program15(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-single-options", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-single-options", "model", options))));
  }

function program17(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-multiple-options", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-multiple-options", "model", options))));
  }

function program19(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-radio-check", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-radio-check", "model", options))));
  }

function program21(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers.render || (depth0 && depth0.render),options={hash:{},hashTypes:{},hashContexts:{},contexts:[depth0,depth0],types:["STRING","ID"],data:data},helper ? helper.call(depth0, "template-field-editor-uploadshow", "model", options) : helperMissing.call(depth0, "render", "template-field-editor-uploadshow", "model", options))));
  }

function program23(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div class=\"form-group\"><label class=\"control-label\">This field is...</label><div class=\"clearfix\"></div><label class=\"checkbox-inline\">");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("checkbox"),
    'checked': ("model.required"),
    'name': ("required")
  },hashTypes:{'type': "STRING",'checked': "ID",'name': "STRING"},hashContexts:{'type': depth0,'checked': depth0,'name': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("Required</label><label class=\"checkbox-inline\">");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("checkbox"),
    'checked': ("model.readonly"),
    'name': ("read-only")
  },hashTypes:{'type': "STRING",'checked': "ID",'name': "STRING"},hashContexts:{'type': depth0,'checked': depth0,'name': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("Read-only</label><label class=\"checkbox-inline\">");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("checkbox"),
    'checked': ("model.visible"),
    'name': ("visible")
  },hashTypes:{'type': "STRING",'checked': "ID",'name': "STRING"},hashContexts:{'type': depth0,'checked': depth0,'name': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("Visible</label></div>");
  return buffer;
  }

function program25(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("<div class=\"form-group\"><label for=\"fieldDefaultValue\" class=\"control-label\">Predefined value</label><p class=\"help-block\">The field's value will be prefilled-in with the following...<br /><mark class=\"text-muted\"><strong>TIP:</strong>&nbsp;Type a curly bracket<strong>&nbsp;{&nbsp;</strong>to <a href=\"https://www.kotive.com/how-to/add-dynamic-field-tags/\" target=\"_blank\">pull-in field values from earlier tasks.</a></mark></p>");
  stack1 = helpers['if'].call(depth0, "defaultStringValue", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(28, program28, data),fn:self.program(26, program26, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  }
function program26(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['atwho-field'] || (depth0 && depth0['atwho-field']),options={hash:{
    'value': ("model.patternString"),
    'classes': ("form-control"),
    'workflow': ("workflow"),
    'field': ("model"),
    'templateActivity': ("templateActivity"),
    'store': ("store")
  },hashTypes:{'value': "ID",'classes': "STRING",'workflow': "ID",'field': "ID",'templateActivity': "ID",'store': "ID"},hashContexts:{'value': depth0,'classes': depth0,'workflow': depth0,'field': depth0,'templateActivity': depth0,'store': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "atwho-field", options))));
  }

function program28(depth0,data) {
  
  var helper, options;
  data.buffer.push(escapeExpression((helper = helpers['atwho-field'] || (depth0 && depth0['atwho-field']),options={hash:{
    'value': ("model.patternString"),
    'classes': ("form-control textarea"),
    'workflow': ("workflow"),
    'field': ("model"),
    'templateActivity': ("templateActivity"),
    'store': ("store"),
    'rows': ("3")
  },hashTypes:{'value': "ID",'classes': "STRING",'workflow': "ID",'field': "ID",'templateActivity': "ID",'store': "ID",'rows': "STRING"},hashContexts:{'value': depth0,'classes': depth0,'workflow': depth0,'field': depth0,'templateActivity': depth0,'store': depth0,'rows': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "atwho-field", options))));
  }

function program30(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div class=\"form-group\"><label for=\"label\" class=\"control-label\">Help text</label><p class=\"help-block\">Give people guidance or instructions related to this field</p>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("text"),
    'class': ("form-control"),
    'value': ("helptext")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div>");
  return buffer;
  }

function program32(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<div class=\"pull-left\"><a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "deleteTemplateField", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-danger btn-sm delete-template-field-btn\"><span class=\"glyphicon glyphicon-trash\"></span>&nbsp;Delete</a>&nbsp;&nbsp;<a ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "duplicateTemplateField", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-default btn-sm\">Clone this field</a></div><div class=\"pull-right save-btn-link\"><button id=\"js-save-field-button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "closeModal", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\"><span class=\"glyphicon glyphicon-ok\"></span>&nbsp;Done</button></div><div class=\"clearfix\"></div>");
  return buffer;
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-container']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-container']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-container']) { stack1 = blockHelperMissing.call(depth0, 'modal-container', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["user-confirmation"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  data.buffer.push("<div id=\"mini\" class=\"container-fluid\"><div class=\"row-fluid\"><div class=\"container-mini center-block\"><form><div class=\"panel panel-kotive\"><div class=\"panel-heading\"><p>Welcome to Kotive</p></div><div class=\"panel-body\"><div id=\"js-password-alert\" class=\"alert alert-warning hidden\"><p>Password is not correct, please ensure you have entered a strong password. The longer the better...</p></div><div id=\"js-company-alert\" class=\"alert alert-warning hidden\"><p>Company is not correct, please ensure you have entered a company name</p></div><div id=\"js-api-error\" class=\"alert alert-warning hidden\"><p>We're busy upgrading the server. Please try again in 10 minutes.</p></div><div class=\"form-group\"><label for=\"label\" class=\"control-label\">Email</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("email"),
    'class': ("form-control email-value"),
    'value': ("model.email"),
    'disabled': (true)
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID",'disabled': "BOOLEAN"},hashContexts:{'type': depth0,'class': depth0,'value': depth0,'disabled': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><div class=\"form-group\"><label for=\"label\" class=\"control-label\">Password</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("password"),
    'class': ("form-control password-value"),
    'value': ("model.password"),
    'required': (true)
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID",'required': "BOOLEAN"},hashContexts:{'type': depth0,'class': depth0,'value': depth0,'required': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><div class=\"form-group\"><label for=\"label\" class=\"control-label\">Company</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("text"),
    'class': ("form-control company-value"),
    'value': ("model.company"),
    'required': (true)
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID",'required': "BOOLEAN"},hashContexts:{'type': depth0,'class': depth0,'value': depth0,'required': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><button id=\"js-confirm-button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "confirmSignup", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-lg btn-block\">Save</button></div></div></form><div class=\"clearfix\"></div></div></div></div>");
  return buffer;
  
});

Ember.TEMPLATES["user-signup"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<form>");
  data.buffer.push(escapeExpression((helper = helpers['modal-header'] || (depth0 && depth0['modal-header']),options={hash:{
    'title': ("Signup for a Kotive account")
  },hashTypes:{'title': "STRING"},hashContexts:{'title': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "modal-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-body']) { stack1 = blockHelperMissing.call(depth0, 'modal-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(6, program6, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-footer']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-footer']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-footer']) { stack1 = blockHelperMissing.call(depth0, 'modal-footer', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(6, program6, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</form>");
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div id=\"js-signup-alert\" class=\"alert alert-warning hidden\"><p>Email is not correct, please enter a valid address</p></div><div id=\"js-api-error\" class=\"alert alert-warning hidden\"><p>We're busy upgrading the server. Please try again in 10 minutes.</p></div><div class=\"form-group\"><label for=\"label\" class=\"control-label\">Email address</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("email"),
    'class': ("form-control email-value"),
    'value': ("model.email")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div>");
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button id=\"js-signup-button\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "submitSignup", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success\">Create your Kotive account</button><div class=\"clearfix\"></div>");
  return buffer;
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-container']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-container']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-container']) { stack1 = blockHelperMissing.call(depth0, 'modal-container', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["user/synchronise"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  


  data.buffer.push("<div class=\"row\"><div class=\"col-xs-6 col-xs-offset-3 col-sm-4 col-sm-offset-4\"><div class=\"card-kotive\"><div class=\"card-heading\">Syncing your account</div><div class=\"card-body\"><img src=\"/images/32201ecd.loading.gif\" />&nbsp;&nbsp;Syncing your taskflows with the Designer.</div></div></div></div>");
  
});

Ember.TEMPLATES["workflow-delete"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "canDeleteTaskflow", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(2, program2, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program2(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push(escapeExpression((helper = helpers['drop-tooltip-header'] || (depth0 && depth0['drop-tooltip-header']),options={hash:{
    'title': ("Sure you want to delete?"),
    'showClose': (true)
  },hashTypes:{'title': "STRING",'showClose': "BOOLEAN"},hashContexts:{'title': depth0,'showClose': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "drop-tooltip-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip-body']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push(escapeExpression((helper = helpers['drop-tooltip-footer-delete-confirm'] || (depth0 && depth0['drop-tooltip-footer-delete-confirm']),options={hash:{
    'action': ("deleteAction")
  },hashTypes:{'action': "STRING"},hashContexts:{'action': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "drop-tooltip-footer-delete-confirm", options))));
  return buffer;
  }
function program3(depth0,data) {
  
  
  data.buffer.push("Deleting this taskflow, all its tasks, their fields and conditions is permanent and<em>&nbsp;there is no undo...</em>");
  }

function program5(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push(escapeExpression((helper = helpers['drop-tooltip-header'] || (depth0 && depth0['drop-tooltip-header']),options={hash:{
    'title': ("You cannot delete this taskflow..."),
    'showClose': (true)
  },hashTypes:{'title': "STRING",'showClose': "BOOLEAN"},hashContexts:{'title': depth0,'showClose': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "drop-tooltip-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(8, program8, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip-body']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(8, program8, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  }
function program8(depth0,data) {
  
  
  data.buffer.push("You need to delete all the tasks in this taskflow before you can delete the taskflow.");
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["workflow-settings"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push(escapeExpression((helper = helpers['modal-header'] || (depth0 && depth0['modal-header']),options={hash:{
    'title': ("Taskflow settings")
  },hashTypes:{'title': "STRING"},hashContexts:{'title': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "modal-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(10, program10, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-body']) { stack1 = blockHelperMissing.call(depth0, 'modal-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(10, program10, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(10, program10, data),fn:self.program(12, program12, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-footer']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-footer']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-footer']) { stack1 = blockHelperMissing.call(depth0, 'modal-footer', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(10, program10, data),fn:self.program(12, program12, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  }
function program2(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "loading", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program3(depth0,data) {
  
  
  data.buffer.push("<p class=\"text-center\"><img src=\"/images/32201ecd.loading.gif\" /></p>");
  }

function program5(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "canEmbed", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(8, program8, data),fn:self.program(6, program6, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program6(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<p>Share this taskflow by posting the direct link to social media or send it via email or embed the taskflow within your website.</p><hr /><h4>Customize your taskflow links</h4><div class=\"form-group\"><label class=\"control-label\">Select the organization/team in which this taskflow's data will be captured.</label><p class=\"help-block\">Learn more about the<a href=\"https://www.kotive.com/how-to/the-structure-within-kotive/\" target=\"_blank\">&nbsp;structure within Kotive</a></p>");
  data.buffer.push(escapeExpression(helpers.view.call(depth0, "select", {hash:{
    'class': ("form-control"),
    'content': ("groupOptions"),
    'optionValuePath': ("content.id"),
    'optionLabelPath': ("content.label"),
    'value': ("linkedGroupId")
  },hashTypes:{'class': "STRING",'content': "ID",'optionValuePath': "STRING",'optionLabelPath': "STRING",'value': "ID"},hashContexts:{'class': depth0,'content': depth0,'optionValuePath': depth0,'optionLabelPath': depth0,'value': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push("</div><div class=\"form-group\"><div class=\"checkbox\"><label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("checkbox"),
    'checked': ("enableJavascript")
  },hashTypes:{'type': "STRING",'checked': "ID"},hashContexts:{'type': depth0,'checked': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("JavaScript enabled (recommended)</label></div></div><div class=\"form-group\"><label class=\"control-label\">Custom label for 'Save' button</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'class': ("form-control"),
    'type': ("text"),
    'value': ("customSaveBtn"),
    'placeholder': ("Save")
  },hashTypes:{'class': "STRING",'type': "STRING",'value': "ID",'placeholder': "STRING"},hashContexts:{'class': depth0,'type': depth0,'value': depth0,'placeholder': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><div class=\"form-group\"><label class=\"control-label\">Custom title for the thank you page</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'class': ("form-control"),
    'type': ("text"),
    'value': ("customThanksTitle"),
    'placeholder': ("Thank you!")
  },hashTypes:{'class': "STRING",'type': "STRING",'value': "ID",'placeholder': "STRING"},hashContexts:{'class': depth0,'type': depth0,'value': depth0,'placeholder': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><div class=\"form-group\"><label class=\"control-label\">Custom message for the thank you page</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'class': ("form-control"),
    'type': ("text"),
    'value': ("customThanksMessage"),
    'placeholder': ("We've received the information and will be in touch shortly.")
  },hashTypes:{'class': "STRING",'type': "STRING",'value': "ID",'placeholder': "STRING"},hashContexts:{'class': depth0,'type': depth0,'value': depth0,'placeholder': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><div class=\"form-group\"><label class=\"control-label\">Custom stylesheet (css)</label><p class=\"help-block\">Link to an external stylesheet (.css) to have more control over the look&feel of your public forms.<br /><strong>Important: </strong>You need to host the .css file on a https:// server.<br />If you host the .css file on Dropbox, then add <strong>?dl=1 </strong>to the end of the link.</p>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'class': ("form-control"),
    'type': ("text"),
    'value': ("customCss")
  },hashTypes:{'class': "STRING",'type': "STRING",'value': "ID"},hashContexts:{'class': depth0,'type': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><hr /><h4>Direct link to your taskflow</h4><div class=\"form-group\"><p>This is a permanent web address (url) to your taskflow. It does not change unless you change the above options.</p>");
  data.buffer.push(escapeExpression((helper = helpers.textarea || (depth0 && depth0.textarea),options={hash:{
    'value': ("directLink"),
    'readonly': (true),
    'class': ("form-control kotive-embedded-scripts"),
    'rows': (3)
  },hashTypes:{'value': "ID",'readonly': "BOOLEAN",'class': "STRING",'rows': "INTEGER"},hashContexts:{'value': depth0,'readonly': depth0,'class': depth0,'rows': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "textarea", options))));
  data.buffer.push("<br /><p class=\"pull-left\"><strong>Easy ways to share this direct link:&nbsp;&nbsp;</strong><a ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'href': ("emailLink")
  },hashTypes:{'href': "STRING"},hashContexts:{'href': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(">Email</a>&nbsp;&nbsp;<a ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'href': ("twitterLink")
  },hashTypes:{'href': "STRING"},hashContexts:{'href': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" target=\"_blank\">Twitter</a>&nbsp;&nbsp;<a ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'href': ("facebookLink")
  },hashTypes:{'href': "STRING"},hashContexts:{'href': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" target=\"_blank\">Facebook</a>&nbsp;&nbsp;<a ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'href': ("linkedInLink")
  },hashTypes:{'href': "STRING"},hashContexts:{'href': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" target=\"_blank\">LinkedIn</a>&nbsp;&nbsp;<a ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'href': ("googlePlusLink")
  },hashTypes:{'href': "STRING"},hashContexts:{'href': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" target=\"_blank\">Google+</a></p></div><div class=\"clearfix\"></div><hr /><h4>Pre-filled link to your taskflow</h4><div class=\"form-group\"><p>Very useful if you want to fill fields automatically in the first task in your taskflow with specific information. E.g include a person's email address, set a specific date or an event they're registering for.</p>");
  data.buffer.push(escapeExpression((helper = helpers.textarea || (depth0 && depth0.textarea),options={hash:{
    'value': ("autofillLink"),
    'readonly': (true),
    'class': ("form-control kotive-embedded-scripts"),
    'rows': (4)
  },hashTypes:{'value': "ID",'readonly': "BOOLEAN",'class': "STRING",'rows': "INTEGER"},hashContexts:{'value': depth0,'readonly': depth0,'class': depth0,'rows': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "textarea", options))));
  data.buffer.push("<p class=\"help-block\"><br />Replace the field values (...) that you want to auto-fill with appropriate values.</p></div><hr /><h4>Wordpress shortcode plugin</h4><div class=\"form-group\"><p>Copy&paste this shortcode to embed a taskflow form into your Wordpress website. You need to have the <a href=\"https://wordpress.org/plugins/kotive-taskflow-shortcode/\" target=\"_blank\">Kotive Taskflow Shortcode Plugin</a>&nbsp;installed on your Wordpress website. </p><input type=\"text\" readonly ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'value': ("embedWordpress")
  },hashTypes:{'value': "STRING"},hashContexts:{'value': depth0},contexts:[],types:[],data:data})));
  data.buffer.push(" class=\"form-control kotive-embedded-scripts\" /></div><br /><h4>Embed this taskflow within your website</h4><div class=\"form-group\"><p>Copy&paste this embed code to insert your taskflow into your website. (recommended)</p>");
  data.buffer.push(escapeExpression((helper = helpers.textarea || (depth0 && depth0.textarea),options={hash:{
    'value': ("embedJavascript"),
    'readonly': (true),
    'class': ("form-control kotive-embedded-scripts"),
    'rows': (11),
    'wrap': ("off")
  },hashTypes:{'value': "ID",'readonly': "BOOLEAN",'class': "STRING",'rows': "INTEGER",'wrap': "STRING"},hashContexts:{'value': depth0,'readonly': depth0,'class': depth0,'rows': depth0,'wrap': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "textarea", options))));
  data.buffer.push("</div><br /><h4>Advanced embedding</h4><div class=\"form-group\"><p>Copy&paste this embed code to insert your taskflow into your website if you have a situation where javascript is unavailable. Make sure to untick 'JavaScript enabled' in the General options.</p>");
  data.buffer.push(escapeExpression((helper = helpers.textarea || (depth0 && depth0.textarea),options={hash:{
    'value': ("embedIframe"),
    'readonly': (true),
    'class': ("form-control kotive-embedded-scripts"),
    'rows': (7),
    'wrap': ("off")
  },hashTypes:{'value': "ID",'readonly': "BOOLEAN",'class': "STRING",'rows': "INTEGER",'wrap': "STRING"},hashContexts:{'value': depth0,'readonly': depth0,'class': depth0,'rows': depth0,'wrap': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "textarea", options))));
  data.buffer.push("</div><br /><h4>Webhook</h4><div class=\"form-group\"><p>Start the taskflow from another application or your own code by posting to this webhook</p>");
  data.buffer.push(escapeExpression((helper = helpers.textarea || (depth0 && depth0.textarea),options={hash:{
    'value': ("webhookLink"),
    'readonly': (true),
    'class': ("form-control kotive-embedded-scripts"),
    'rows': (6)
  },hashTypes:{'value': "ID",'readonly': "BOOLEAN",'class': "STRING",'rows': "INTEGER"},hashContexts:{'value': depth0,'readonly': depth0,'class': depth0,'rows': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "textarea", options))));
  data.buffer.push("<p class=\"help-block\"><br />Replace the field values (...) with the flattened strings (e.g. `invitee.firstname` or `issue.user.avatar_url`) from your POST's payload that you want to use and remove any fields (e.g. `_007` or `_1002`) you do not need.</p></div>");
  return buffer;
  }

function program8(depth0,data) {
  
  
  data.buffer.push("<p><strong>Please note:&nbsp;</strong>in order to share a direct link to a taskflow or embed it within your website, the first level in the taskflow must contain at least one form task that is marked as published.</p>");
  }

function program10(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program12(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<div class=\"pull-left\"><button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "deleteWorkflow", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-danger btn-sm delete-workflow-btn\"><span class=\"glyphicon glyphicon-trash cursor\"></span>&nbsp;Delete this taskflow</button></div><div class=\"pull-right\"><button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "closeModal", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-default\">Close</button></div><div class=\"clearfix\"></div>");
  return buffer;
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(10, program10, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['modal-container']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['modal-container']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['modal-container']) { stack1 = blockHelperMissing.call(depth0, 'modal-container', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(10, program10, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});

Ember.TEMPLATES["workflow"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  data.buffer.push("<span class=\"glyphicon glyphicon-chevron-left icon-white\"></span>");
  }

function program3(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("text"),
    'class': ("form-control workflow-label-edit"),
    'value': ("updatedLabel")
  },hashTypes:{'type': "STRING",'class': "STRING",'value': "ID"},hashContexts:{'type': depth0,'class': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("&nbsp; <button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "updateWorkflowLabel", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-sm\"><span class=\"glyphicon glyphicon-ok icon-white\"></span>&nbsp;&nbsp;Save</button><button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "editWorkflowLabelCancel", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-link btn-sm\"><span class=\"glyphicon glyphicon-remove icon-white cursor\"></span></button>");
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = '', stack1;
  stack1 = helpers._triageMustache.call(depth0, "model.label", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers.unless.call(depth0, "updatingLabel", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(8, program8, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  return buffer;
  }
function program8(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "editWorkflowLabel", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-link btn-sm\"><span class=\"glyphicon glyphicon-pencil icon-white cursor\"></span></button>");
  return buffer;
  }

function program10(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, "currentUserIsLoggedIn", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(13, program13, data),fn:self.program(11, program11, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  }
function program11(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button id=\"goto-mock-taskflow\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "createTaskflow", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-sm pull-right hidden-xs\"><span class=\"glyphicon glyphicon-eye-open white\"></span>&nbsp; Preview </button><button id=\"goto-mock-taskflow\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "createTaskflow", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-sm pull-right visible-xs-block\"><span class=\"glyphicon glyphicon-eye-open white\"></span></button>");
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = '';
  data.buffer.push("<button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "openSignupModal", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-sm pull-right hidden-xs\"><span class=\"glyphicon glyphicon-eye-open white\"></span>&nbsp; Signup to preview your taskflow </button><button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "openSignupModal", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-sm pull-right visible-xs-block\"><span class=\"glyphicon glyphicon-eye-open white\"></span>&nbsp; Signup to preview </button>");
  return buffer;
  }

  data.buffer.push("<div class=\"site-view\"><div ");
  data.buffer.push(escapeExpression(helpers['bind-attr'].call(depth0, {hash:{
    'class': (":workflow-designer-container :col-md-6 showFlowDesigner:shown:hidden")
  },hashTypes:{'class': "STRING"},hashContexts:{'class': depth0},contexts:[],types:[],data:data})));
  data.buffer.push("><div class=\"panel panel-kotive\"><div class=\"panel-heading\"><span class=\"pull-left\"><div class=\"inline\"><div class=\"form-inline\"><div style=\"margin-bottom: 0px;\" class=\"form-group\">");
  stack1 = (helper = helpers['link-to'] || (depth0 && depth0['link-to']),options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["STRING"],data:data},helper ? helper.call(depth0, "designer.workflows", options) : helperMissing.call(depth0, "link-to", "designer.workflows", options));
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("&nbsp; ");
  stack1 = helpers['if'].call(depth0, "editingLabel", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div></div></div></span><span class=\"pull-right\"><button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "editSettings", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-sm pull-right hidden-xs\"><span class=\"glyphicon glyphicon-cog white\"></span>&nbsp; Taskflow settings </button><button ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "editSettings", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" class=\"btn btn-success btn-sm pull-right visible-xs-block\"><span class=\"glyphicon glyphicon-cog white\"></span></button><span class=\"pull-right\">&nbsp;</span>");
  stack1 = helpers['if'].call(depth0, "model.orderedTemplateActivities", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(10, program10, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</span><div class=\"clearfix\"></div></div><div class=\"panel-body panel-kotive-flow\"><div id=\"kotive-flow-container\" class=\"designer-activities kotive-flow-container\"></div></div></div></div>");
  stack1 = helpers._triageMustache.call(depth0, "outlet", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</div>");
  return buffer;
  
});

Ember.TEMPLATES["workflows-add"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("<form id=\"add-new-taskflow-form\" role=\"form\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "submit", {hash:{
    'on': ("submit")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push(" onsubmit=\"return false;\">");
  data.buffer.push(escapeExpression((helper = helpers['drop-tooltip-header'] || (depth0 && depth0['drop-tooltip-header']),options={hash:{
    'title': ("Design a new taskflow")
  },hashTypes:{'title': "STRING"},hashContexts:{'title': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "drop-tooltip-header", options))));
  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip-body']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip-body']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip-body']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip-body', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  stack1 = helpers._triageMustache.call(depth0, "drop-tooltip-footer", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</form>");
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("<div class=\"form-group\"><label class=\"control-label\">Taskflow label</label>");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("text"),
    'id': ("new-workflow-title"),
    'value': ("model.label"),
    'class': ("form-control title-value")
  },hashTypes:{'type': "STRING",'id': "STRING",'value': "ID",'class': "STRING"},hashContexts:{'type': depth0,'id': depth0,'value': depth0,'class': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("</div><p class=\"help-block\">Or do you need inspiration? <a href=\"#\" ");
  data.buffer.push(escapeExpression(helpers.action.call(depth0, "showTaskflowRecipes", {hash:{
    'on': ("click")
  },hashTypes:{'on': "STRING"},hashContexts:{'on': depth0},contexts:[depth0],types:["STRING"],data:data})));
  data.buffer.push("><strong>Choose a template &rarr;</strong></a></p>");
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = '';
  return buffer;
  }

  options={hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}
  if (helper = helpers['drop-tooltip']) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0['drop-tooltip']); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers['drop-tooltip']) { stack1 = blockHelperMissing.call(depth0, 'drop-tooltip', {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),contexts:[],types:[],data:data}); }
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  else { data.buffer.push(''); }
  
});